import type { ContentItem } from '../contentLibrary'

export const SONG_ARTICLES: ContentItem[] = [
  {
    id: 'poem-shuidiaogetou',
    category: 'poem',
    dynasty: 'song',
    title: '水調歌頭',
    source: '蘇軾',
    description: '中秋賞月詞中的絕唱，抒發對人間親情與世事流轉的哲思。',
    content: '明月幾時有？把酒問青天。不知天上宮闕，今夕是何年。我欲乘風歸去，又恐瓊樓玉宇，高處不勝寒。起舞弄清影，何似在人間。轉朱閣，低綺戶，照無眠。不應有恨，何事長向別時圓？人有悲歡離合，月有陰晴圓缺，此事古難全。但願人長久，千里共嬋娟。',
  },

  {
    id: 'poem-niannujiao',
    category: 'poem',
    dynasty: 'song',
    title: '念奴嬌·赤壁懷古',
    source: '蘇軾',
    description: '豪放派宋詞巔峰之作，借赤壁古戰場抒發英雄遲暮之悲。',
    content: '大江東去，浪淘盡，千古風流人物。故壘西邊，人道是，三國周郎赤壁。亂石穿空，驚濤拍岸，捲起千堆雪。江山如畫，一時多少豪傑。遙想公瑾當年，小喬初嫁了，雄姿英發。羽扇綸巾，談笑間，檣櫓灰飛煙滅。故國神遊，多情應笑我，早生華髮。人生如夢，一尊還酹江月。',
  },

  {
    id: 'poem-qingyuan元夕',
    category: 'poem',
    dynasty: 'song',
    title: '青玉案·元夕',
    source: '辛棄疾',
    description: '描寫元宵佳節繁華景色，最後「燈火闌珊處」寓意深刻。',
    content: '東風夜放花千樹。更吹落、星如雨。寶馬雕車香滿路。鳳簫聲動，玉壺光轉，一夜魚龍舞。蛾兒雪柳黃金縷。笑語盈盈暗香去。眾裡尋他千百度。驀然回首，那人卻在，燈火闌珊處。',
  },

  {
    id: 'poem-shengshengman',
    category: 'poem',
    dynasty: 'song',
    title: '聲聲慢',
    source: '李清照',
    description: '機具代表性的婉約詞，疊字運用妙極，極致抒發憂鬱悲涼。',
    content: '尋尋覓覓，冷冷清清，悽悽慘慘戚戚。乍暖還寒時候，最難將息。三杯兩盞淡酒，怎敵他、晚來風急！雁過也，正傷心，卻是舊時相識。滿地黃花堆積，憔悴損，如今有誰堪摘？守著窗兒，獨自怎生得黑！梧桐更兼細雨，到黃昏、點點滴滴。這次第，怎一個愁字了得！',
  },

  {
    id: 'poem-manjianghong',
    category: 'poem',
    dynasty: 'song',
    title: '滿江紅',
    source: '岳飛',
    description: '岳飛愛國名篇，慷慨壯烈，激勵千古。',
    content: '怒髮衝冠，憑欄處、瀟瀟雨歇。抬望眼、仰天長嘯，壯懷激烈。三十功名塵與土，八千里路雲和月。莫等閒、白了少年頭，空悲切。靖康恥，猶未雪。臣子恨，何時滅。駕長車，踏破賀蘭山缺。壯志飢餐胡虜肉，笑談渴飲匈奴血。待從頭、收拾舊山河，朝天闕。',
  },

  {
    id: 'poem-yumeiren',
    category: 'poem',
    dynasty: 'song',
    title: '虞美人',
    source: '李煜',
    description: '李煜絕命詞，滿懷亡國之痛與故國之思，哀婉動人。',
    content: '春花秋月何時了？往事知多少。小樓昨夜又東風，故國不堪回首月明中。雕欄玉砌應猶在，只是朱顏改。問君能有幾多愁？恰似一江春水向東流。',
  },

  {
    id: 'poem-rumengling',
    category: 'poem',
    dynasty: 'song',
    title: '如夢令',
    source: '李清照',
    description: '李清照早年名作，寫溪亭醉遊的歡快場景，筆調輕靈。',
    content: '常記溪亭日暮，沉醉不知歸路。興盡晚回舟，誤入藕花深處。爭渡，爭渡，驚起一灘鷗鷺。',
  },

  {
    id: 'poem-dingfengbo',
    category: 'poem',
    dynasty: 'song',
    title: '定風波',
    source: '蘇軾',
    description: '蘇軾曠達胸懷的代表作，「也無風雨也無晴」道盡人生哲思。',
    content: '莫聽穿林打葉聲，何妨吟嘯且徐行。竹杖芒鞋輕勝馬，誰怕？一蓑煙雨任平生。料峭春風吹酒醒，微冷，山頭斜照卻相迎。回首向來蕭瑟處，歸去，也無風雨也無晴。',
  },

  {
    id: 'classic-ailianshuo',
    category: 'classic',
    dynasty: 'song',
    title: '愛蓮說',
    source: '周敦頤',
    description: '以蓮自況，頌揚潔身自好、不同流合污的君子美德。',
    content: '水陸草木之花，可愛者甚蕃。晉陶淵明獨愛菊。自李唐來，世人甚愛牡丹。予獨愛蓮之出淤泥而不染，濯清漣而不妖，中通外直，不蔓不枝，香遠益清，亭亭淨植，可遠觀而不可褻玩焉。予謂菊，花之隱逸者也；牡丹，花之富貴者也；蓮，花之君子者也。噫！菊之愛，陶後鮮有聞。蓮之愛，同予者何人？牡丹之愛，宜乎眾矣！',
  },

  {
    id: 'classic-yueyanglouji',
    category: 'classic',
    dynasty: 'song',
    title: '岳陽樓記',
    source: '范仲淹',
    description: '范仲淹借岳陽樓之景抒發「先憂後樂」的政治抱負。',
    content: '慶曆四年春，滕子京謫守巴陵郡。越明年，政通人和，百廢具興。乃重修岳陽樓，增其舊制，刻唐賢今人詩賦於其上。屬予作文以記之。予觀夫巴陵勝狀，在洞庭一湖。銜遠山，吞長江，浩浩湯湯，橫無際涯；朝暉夕陰，氣象萬千。此則岳陽樓之大觀也，前人之述備矣。然則北通巫峽，南極瀟湘，遷客騷人，多會於此，覽物之情，得無異乎？若夫淫雨霏霏，連月不開，陰風怒號，濁浪排空；日星隱曜，山岳潛形；商旅不行，檣傾楫摧；薄暮冥冥，虎嘯猿啼。登斯樓也，則有去國懷鄉，憂讒畏譏，滿目蕭然，感極而悲者矣。至若春和景明，波瀾不驚，上下天光，一碧萬頃；沙鷗翔集，錦鱗游泳；岸芷汀蘭，郁郁青青。而或長煙一空，皓月千里，浮光躍金，靜影沉璧，漁歌互答，此樂何極！登斯樓也，則有心曠神怡，寵辱偕忘，把酒臨風，其喜洋洋者矣。嗟夫！予嘗求古仁人之心，或異二者之為，何哉？不以物喜，不以己悲；居廟堂之高則憂其民；處江湖之遠則憂其君。是進亦憂，退亦憂。然則何時而樂耶？其必曰「先天下之憂而憂，後天下之樂而樂」乎？微斯人，吾誰與歸？',
  },

  {
    id: 'classic-zuishongtingji',
    category: 'classic',
    dynasty: 'song',
    title: '醉翁亭記',
    source: '歐陽修',
    description: '歐陽修散文名篇，「醉翁之意不在酒，在乎山水之間也」傳誦千古。',
    content: '環滁皆山也。其西南諸峰，林壑尤美，望之蔚然而深秀者，琅琊也。山行六七里，漸聞水聲潺潺，而瀉出於兩峰之間者，釀泉也。峰迴路轉，有亭翼然臨於泉上者，醉翁亭也。作亭者誰？山之僧智仙也。名之者誰？太守自謂也。太守與客來飲於此，飲少輒醉，而年又最高，故自號曰醉翁也。醉翁之意不在酒，在乎山水之間也。山水之樂，得之心而寓之酒也。若夫日出而林霏開，雲歸而岩穴暝，晦明變化者，山間之朝暮也。野芳發而幽香，佳木秀而繁陰，風霜高潔，水落而石出者，山間之四時也。朝而往，暮而歸，四時之景不同，而樂亦無窮也。至於負者歌於途，行者休於樹，前者呼，後者應，傴僂提攜，往來而不絕者，滁人遊也。臨溪而漁，溪深而魚肥；釀泉為酒，泉香而酒洌；山肴野蔌，雜然而前陳者，太守宴也。宴酣之樂，非絲非竹，射者中，弈者勝，觥籌交錯，起坐而喧嘩者，眾賓歡也。蒼顏白髮，頹然乎其間者，太守醉也。已而夕陽在山，人影散亂，太守歸而賓客從也。樹林陰翳，鳴聲上下，遊人去而禽鳥樂也。然而禽鳥知山林之樂，而不知人之樂；人知從太守遊而樂，而不知太守之樂其樂也。醉能同其樂，醒能述以文者，太守也。太守謂誰？廬陵歐陽修也。',
  },

  {
    id: 'classic-chibifu',
    category: 'classic',
    dynasty: 'song',
    title: '前赤壁賦',
    source: '蘇軾',
    description: '蘇軾貶謫黃州時所作，以水月之喻闡發通達的人生觀。',
    content: '壬戌之秋，七月既望，蘇子與客泛舟遊於赤壁之下。清風徐來，水波不興。舉酒屬客，誦明月之詩，歌窈窕之章。少焉，月出於東山之上，徘徊於斗牛之間。白露橫江，水光接天。縱一葦之所如，凌萬頃之茫然。浩浩乎如馮虛御風，而不知其所止；飄飄乎如遺世獨立，羽化而登仙。於是飲酒樂甚，扣舷而歌之。歌曰：「桂棹兮蘭槳，擊空明兮溯流光。渺渺兮予懷，望美人兮天一方。」客有吹洞簫者，倚歌而和之。其聲嗚嗚然，如怨如慕，如泣如訴；餘音嫋嫋，不絕如縷。舞幽壑之潛蛟，泣孤舟之嫠婦。蘇子愀然，正襟危坐，而問客曰：「何為其然也？」客曰：「『月明星稀，烏鵲南飛。』此非曹孟德之詩乎？西望夏口，東望武昌，山川相繆，鬱乎蒼蒼，此非曹孟德之困於周郎者乎？方其破荊州，下江陵，順流而東也，舳艫千里，旌旗蔽空，釃酒臨江，橫槊賦詩，固一世之雄也，而今安在哉？況吾與子漁樵於江渚之上，侶魚蝦而友麋鹿，駕一葉之扁舟，舉匏樽以相屬。寄蜉蝣於天地，渺滄海之一粟。哀吾生之須臾，羨長江之無窮。挾飛仙以遨遊，抱明月而長終。知不可乎驟得，託遺響於悲風。」蘇子曰：「客亦知夫水與月乎？逝者如斯，而未嘗往也；盈虛者如彼，而卒莫消長也。蓋將自其變者而觀之，則天地曾不能以一瞬；自其不變者而觀之，則物與我皆無盡也，而又何羨乎！且夫天地之間，物各有主，苟非吾之所有，雖一毫而莫取。惟江上之清風，與山間之明月，耳得之而為聲，目遇之而成色，取之無禁，用之不竭。是造物者之無盡藏也，而吾與子之所共適。」客喜而笑，洗盞更酌。肴核既盡，杯盤狼籍。相與枕藉乎舟中，不知東方之既白。',
  },

  {
    id: 'classic-sanzijing',
    category: 'classic',
    dynasty: 'song',
    title: '三字經',
    source: '蒙學經典',
    description: '適合孩童與基礎認字。',
    content: '人之初，性本善。性相近，習相遠。苟不教，性乃遷。教之道，貴以專。昔孟母，擇鄰處。子不學，斷機杼。竇燕山，有義方。教五子，名俱揚。養不教，父之過。教不嚴，師之惰。子不學，非所宜。幼不學，老何為。玉不琢，不成器。人不學，不知義。為人子，方少時。親師友，習禮儀。香九齡，能溫席。孝於親，所當執。融四歲，能讓梨.弟於長，宜先知。首孝悌，次見聞。知某數，識某文。一而十，十而百。百而千，千而萬。三才者，天地人。三光者，日月星。三綱者，君臣義。父子親，夫婦順。曰春夏，曰秋冬。此四時，運不窮。曰南北，曰西東。此四方，應乎中。曰水火，木金土。此五行，本乎數。十干者，甲至癸。十二支，子至亥。曰黃道，日所纏。曰赤道，陸地寬。赤道下，溫暖極。我中華，在東北。曰江河，曰淮濟。此四瀆，水之紀。曰戴華，衡恆嵩。宇五嶽，群山尊。',
  },

  {
    id: 'poem-jiangchenglie',
    category: 'poem',
    dynasty: 'song',
    title: '江城子·密州出獵',
    source: '蘇軾',
    description: '蘇軾豪放詞代表作，氣勢恢宏。',
    content: '老夫聊發少年狂，左牽黃，右擎蒼，錦帽貂裘，千騎卷平岡。為報傾城隨太守，親射虎，看孫郎。酒酣胸膽尚開張，鬢微霜，又何妨！持節雲中，何日遣馮唐？會挽雕弓如滿月，西北望，射天狼。',
  },

  {
    id: 'poem-jiangchengji',
    category: 'poem',
    dynasty: 'song',
    title: '江城子·乙卯正月二十日夜記夢',
    source: '蘇軾',
    description: '蘇軾悼念亡妻王弗，深情婉轉，令人動容。',
    content: '十年生死兩茫茫，不思量，自難忘。千里孤墳，無處話淒涼。縱使相逢應不識，塵滿面，鬢如霜。夜來幽夢忽還鄉，小軒窗，正梳妝。相顧無言，惟有淚千行。料得年年腸斷處，明月夜，短松岡。',
  },

  {
    id: 'poem-tixibilin',
    category: 'poem',
    dynasty: 'song',
    title: '題西林壁',
    source: '蘇軾',
    description: '蘇軾遊廬山所作，富含哲理。',
    content: '橫看成嶺側成峰，遠近高低各不同。不識廬山真面目，只緣身在此山中。',
  },

  {
    id: 'poem-yinhu',
    category: 'poem',
    dynasty: 'song',
    title: '飲湖上初晴後雨',
    source: '蘇軾',
    description: '以西湖比西子，千古名句。',
    content: '水光瀲灩晴方好，山色空濛雨亦奇。欲把西湖比西子，淡妝濃抹總相宜。',
  },

  {
    id: 'poem-huichong',
    category: 'poem',
    dynasty: 'song',
    title: '惠崇春江晚景',
    source: '蘇軾',
    description: '蘇軾題畫詩，春意盎然。',
    content: '竹外桃花三兩枝，春江水暖鴨先知。蔞蒿滿地蘆芽短，正是河豚欲上時。',
  },

  {
    id: 'poem-huanxisha',
    category: 'poem',
    dynasty: 'song',
    title: '浣溪沙',
    source: '蘇軾',
    description: '蘇軾貶謫黃州時所作，曠達樂觀。',
    content: '山下蘭芽短浸溪，松間沙路淨無泥，蕭蕭暮雨子規啼。誰道人生無再少？門前流水尚能西！休將白髮唱黃雞。',
  },

  {
    id: 'poem-dielianhua',
    category: 'poem',
    dynasty: 'song',
    title: '蝶戀花·春景',
    source: '蘇軾',
    description: '蘇軾傷春之作，婉約中見灑脫。',
    content: '花褪殘紅青杏小。燕子來時，綠水人家繞。枝上柳綿吹又少，天涯何處無芳草。牆裡鞦韆牆外道。牆外行人，牆裡佳人笑。笑漸不聞聲漸悄，多情卻被無情惱。',
  },

  {
    id: 'poem-yijianmei',
    category: 'poem',
    dynasty: 'song',
    title: '一剪梅',
    source: '李清照',
    description: '李清照思念丈夫趙明誠之作，「此情無計可消除」傳誦千古。',
    content: '紅藕香殘玉簟秋。輕解羅裳，獨上蘭舟。雲中誰寄錦書來？雁字回時，月滿西樓。花自飄零水自流。一種相思，兩處閒愁。此情無計可消除，才下眉頭，卻上心頭。',
  },

  {
    id: 'poem-wulingchun',
    category: 'poem',
    dynasty: 'song',
    title: '武陵春',
    source: '李清照',
    description: '李清照晚年避亂金華，感懷身世之作。',
    content: '風住塵香花已盡，日晚倦梳頭。物是人非事事休，欲語淚先流。聞說雙溪春尚好，也擬泛輕舟。只恐雙溪舴艋舟，載不動許多愁。',
  },

  {
    id: 'poem-zuihuayin',
    category: 'poem',
    dynasty: 'song',
    title: '醉花陰',
    source: '李清照',
    description: '李清照重陽懷人名篇，「人比黃花瘦」傳神之極。',
    content: '薄霧濃雲愁永晝，瑞腦銷金獸。佳節又重陽，玉枕紗廚，半夜涼初透。東籬把酒黃昏後，有暗香盈袖。莫道不銷魂，簾捲西風，人比黃花瘦。',
  },

  {
    id: 'poem-xiari',
    category: 'poem',
    dynasty: 'song',
    title: '夏日絕句',
    source: '李清照',
    description: '借項羽諷南宋朝廷苟安，慷慨雄健。',
    content: '生當作人傑，死亦為鬼雄。至今思項羽，不肯過江東。',
  },

  {
    id: 'poem-dianjiangchun',
    category: 'poem',
    dynasty: 'song',
    title: '點絳唇',
    source: '李清照',
    description: '李清照少女時代的嬌羞情態，婉約靈動。',
    content: '蹴罷鞦韆，起來慵整纖纖手。露濃花瘦，薄汗輕衣透。見客入來，襪剗金釵溜。和羞走，倚門回首，卻把青梅嗅。',
  },

  {
    id: 'poem-qingpingle',
    category: 'poem',
    dynasty: 'song',
    title: '清平樂',
    source: '李清照',
    description: '李清照晚年詠梅，暗寓身世飄零之感。',
    content: '年年雪裡，常插梅花醉。挼盡梅花無好意，贏得滿衣清淚。今年海角天涯，蕭蕭兩鬢生華。看取晚來風勢，故應難看梅花。',
  },

  {
    id: 'poem-posamon',
    category: 'poem',
    dynasty: 'song',
    title: '菩薩蠻',
    source: '李清照',
    description: '李清照閨情詞，情深意切。',
    content: '歸鴻聲斷殘雲碧，背窗雪落爐煙直。燭底鳳釵明，釵頭人勝輕。角聲催曉漏，曙色回牛斗。春意看花難，西風留舊寒。',
  },

  {
    id: 'poem-lixiangdielianhua',
    category: 'poem',
    dynasty: 'song',
    title: '蝶戀花',
    source: '李清照',
    description: '李清照寄姊妹之作，離情別緒真切動人。',
    content: '淚濕羅衣脂粉滿，四疊陽關，唱到千千遍。人道山長山又斷，蕭蕭微雨聞孤館。惜別傷離方寸亂，忘了臨行，酒盞深和淺。好把音書憑過雁，東萊不似蓬萊遠。',
  },

  {
    id: 'poem-xijiangyue',
    category: 'poem',
    dynasty: 'song',
    title: '西江月·夜行黃沙道中',
    source: '辛棄疾',
    description: '辛棄疾田園詞代表作，清新活潑。',
    content: '明月別枝驚鵲，清風半夜鳴蟬。稻花香裡說豐年，聽取蛙聲一片。七八個星天外，兩三點雨山前。舊時茅店社林邊，路轉溪橋忽見。',
  },

  {
    id: 'poem-pozhenzi',
    category: 'poem',
    dynasty: 'song',
    title: '破陣子·為陳同甫賦壯詞以寄之',
    source: '辛棄疾',
    description: '辛棄疾壯詞名篇，夢迴軍營，壯志難酬。',
    content: '醉裡挑燈看劍，夢迴吹角連營。八百里分麾下炙，五十弦翻塞外聲，沙場秋點兵。馬作的盧飛快，弓如霹靂弦驚。了卻君王天下事，贏得生前身後名。可憐白髮生！',
  },

  {
    id: 'poem-chounuer',
    category: 'poem',
    dynasty: 'song',
    title: '醜奴兒·書博山道中壁',
    source: '辛棄疾',
    description: '少年不識愁滋味，為賦新詞強說愁，深刻雋永。',
    content: '少年不識愁滋味，愛上層樓。愛上層樓，為賦新詞強說愁。而今識盡愁滋味，欲說還休。欲說還休，卻道天涼好個秋。',
  },

  {
    id: 'poem-yongyule',
    category: 'poem',
    dynasty: 'song',
    title: '永遇樂·京口北固亭懷古',
    source: '辛棄疾',
    description: '辛棄疾登北固亭懷古，感慨英雄不再。',
    content: '千古江山，英雄無覓，孫仲謀處。舞榭歌臺，風流總被，雨打風吹去。斜陽草樹，尋常巷陌，人道寄奴曾住。想當年，金戈鐵馬，氣吞萬里如虎。元嘉草草，封狼居胥，贏得倉皇北顧。四十三年，望中猶記，烽火揚州路。可堪回首，佛狸祠下，一片神鴉社鼓。憑誰問，廉頗老矣，尚能飯否？',
  },

  {
    id: 'poem-posazi',
    category: 'poem',
    dynasty: 'song',
    title: '菩薩蠻·書江西造口壁',
    source: '辛棄疾',
    description: '辛棄疾借山水抒發家國之痛。',
    content: '鬱孤台下清江水，中間多少行人淚。西北望長安，可憐無數山。青山遮不住，畢竟東流去。江晚正愁余，山深聞鷓鴣。',
  },

  {
    id: 'poem-nanxiangzi',
    category: 'poem',
    dynasty: 'song',
    title: '南鄉子·登京口北固亭有懷',
    source: '辛棄疾',
    description: '辛棄疾登北固亭，遙想孫權年少英雄。',
    content: '何處望神州？滿眼風光北固樓。千古興亡多少事？悠悠。不盡長江滾滾流。年少萬兜鍪，坐斷東南戰未休。天下英雄誰敵手？曹劉。生子當如孫仲謀。',
  },

  {
    id: 'poem-qingpinglecunju',
    category: 'poem',
    dynasty: 'song',
    title: '清平樂·村居',
    source: '辛棄疾',
    description: '辛棄疾田園詞，描寫一家五口其樂融融的場景。',
    content: '茅簷低小，溪上青青草。醉裡吳音相媚好，白髮誰家翁媼？大兒鋤豆溪東，中兒正織雞籠。最喜小兒亡賴，溪頭臥剝蓮蓬。',
  },

  {
    id: 'poem-zhegutian',
    category: 'poem',
    dynasty: 'song',
    title: '鷓鴣天·代人賦',
    source: '辛棄疾',
    description: '辛棄疾以春色寫離愁，委婉深沉。',
    content: '晚日寒鴉一片愁，柳塘新綠卻溫柔。若教眼底無離恨，不信人間有白頭。腸已斷，淚難收，相思重上小紅樓。情知已被山遮斷，頻倚闌干不自由。',
  },

  {
    id: 'poem-moyuer',
    category: 'poem',
    dynasty: 'song',
    title: '摸魚兒',
    source: '辛棄疾',
    description: '辛棄疾借宮怨抒發壯志難酬之悲。',
    content: '更能消幾番風雨，匆匆春又歸去。惜春長怕花開早，何況落紅無數。春且住。見說道、天涯芳草無歸路。怨春不語。算只有殷勤，畫簷蛛網，盡日惹飛絮。長門事，準擬佳期又誤。蛾眉曾有人妒。千金縱買相如賦，脈脈此情誰訴？君莫舞。君不見、玉環飛燕皆塵土。閒愁最苦。休去倚危欄，斜陽正在，煙柳斷腸處。',
  },

  {
    id: 'classic-maiyouweng',
    category: 'classic',
    dynasty: 'song',
    title: '賣油翁',
    source: '歐陽修',
    description: '歐陽修以賣油翁酌油之技，喻熟能生巧之理。',
    content: '陳康肅公堯咨善射，當世無雙，公亦以此自矜。嘗射於家圃，有賣油翁釋擔而立，睨之，久而不去。見其發矢十中八九，但微頷之。康肅問曰：「汝亦知射乎？吾射不亦精乎？」翁曰：「無他，但手熟爾。」康肅忿然曰：「爾安敢輕吾射！」翁曰：「以我酌油知之。」乃取一葫蘆置於地，以錢覆其口，徐以杓酌油瀝之，自錢孔入，而錢不濕。因曰：「我亦無他，惟手熟爾。」康肅笑而遣之。',
  },

  {
    id: 'classic-liuguolun',
    category: 'classic',
    dynasty: 'song',
    title: '六國論',
    source: '蘇洵',
    description: '蘇洵以六國賂秦而亡，諷諫宋朝勿屈膝求和。',
    content: '六國破滅，非兵不利，戰不善，弊在賂秦。賂秦而力虧，破滅之道也。或曰：「六國互喪，率賂秦耶？」曰：「不賂者以賂者喪，蓋失強援，不能獨完。故曰『弊在賂秦』也。」秦以攻取之外，小則獲邑，大則得城。較秦之所得，與戰勝而得者，其實百倍；諸侯之所亡，與戰敗而亡者，其實亦百倍。則秦之所大欲，諸侯之所大憂，非兵革之災。思厥先祖父，暴霜露，斬荊棘，以有尺寸之地。子孫視之不甚惜，舉以予人，如棄草芥。今日割五城，明日割十城，然後得一夕安寢。起視四境，而秦兵又至矣。然則諸侯之地有限，暴秦之欲無厭，奉之彌繁，侵之愈急。故不戰而強弱勝負已判矣。至於顛覆，理固宜然。古人云：「以地事秦，猶抱薪救火，薪不盡，火不滅。」此言得之。齊人未嘗賂秦，終繼五國遷滅，何哉？與贏而不助五國也。五國既喪，齊亦不免矣。燕趙之君，始有遠略，能守其土，義不賂秦。是故燕雖小國而後亡，斯用兵之效也。至丹以荊卿為計，始速禍焉。趙嘗五戰秦，二敗而三勝。後秦擊趙者再，李牧連卻之。洎牧以讒誅，邯鲖為郡，惜其用武而不終也。且燕趙處秦革滅殆盡之際，可謂智力孤危，戰敗而亡，誠不得已。向使三國各愛其地，齊人勿附於秦，刺客不行，良將猶在，則勝負之數，存亡之理，當與秦相較，或未易量。嗚呼！以賂秦之地，封天下之奇才，以事秦之心，禮天下之奇才，並力西嚮，則吾恐秦人食不下咽也。悲夫！有如此之勢，而為秦人積威之所劫，日削月割，以趨於亡。為國者無使為積威之所劫哉！夫六國與秦皆諸侯，其勢弱於秦，而猶有可以不賂而勝之之勢。防不勝防。',
  },

  {
    id: 'classic-houchibifu',
    category: 'classic',
    dynasty: 'song',
    title: '後赤壁賦',
    source: '蘇軾',
    description: '蘇軾再遊赤壁，以夢鶴寄寓超脫曠達之思。',
    content: '是歲十月之望，步自雪堂，將歸於臨皋。二客從予過黃泥之坂。霜露既降，木葉盡脫，人影在地，仰見明月，顧而樂之，行歌相答。已而歎曰：「有客無酒，有酒無肴，月白風清，如此良夜何！」客曰：「今者薄暮，舉網得魚，巨口細鱗，狀如松江之鱸。顧安所得酒乎？」歸而謀諸婦。婦曰：「我有斗酒，藏之久矣，以待子不時之需。」於是攜酒與魚，復遊於赤壁之下。江流有聲，斷岸千尺；山高月小，水落石出。曾日月之幾何，而江山不可復識矣。予乃攝衣升堂，履巉岩，披蒙茸，踞虎豹，登虬龍，攀棲鶻之危巢，俯馮夷之幽宮。蓋二客之不能從也。劃然長嘯，草木震動，山鳴谷應，風起水湧。予亦悄然而悲，肅然而恐，凜乎其不可留也。反而登舟，放乎中流，聽其所止而休焉。時夜將半，四顧寂寥。適有孤鶴，橫江東來。翅如車輪，玄裳縞衣，戛然長鳴，掠予舟而西也。須臾客去，予亦就睡。夢一道士，羽衣蹁躚，過臨皋之下，揖予而言曰：「赤壁之遊樂乎？」問其姓名，俯而不答。「嗚呼！噫嘻！我知之矣。疇昔之夜，飛鳴過我者，非子也邪？」道士顧笑，予亦驚寤。開戶避之，不見其處。',
  },

  {
    id: 'classic-youbaochanshan',
    category: 'classic',
    dynasty: 'song',
    title: '遊褒禪山記',
    source: '王安石',
    description: '王安石以遊山洞喻學者治學，需有志與力。',
    content: '褒禪山亦謂之華山。唐浮圖慧褒始舍於其址，而卒葬之，以故其後名之曰「褒禪」。今所謂慧空禪院者，褒之廬冢也。左右皆石，名之曰「華山洞」。其下平曠，有泉側出，而記遊者甚眾，所謂前洞也。由山以上五六里，有穴窈然，入之甚寒，問其深，則其好遊者不能窮也，謂之後洞。余與四人擁火以入，入之愈深，其進愈難，而其見愈奇。有怠而欲出者，曰：「不出，火且盡。」遂與之俱出。蓋余所至，比好遊者尚深，然比起深者，曾不能十一。然力足以至焉而不至，憂在後人；力不足者，憂在己也。既其出，則或咎其欲出者，而余亦悔其隨之，而不得極夫遊之樂也。於是余有嘆焉。古人之觀於天地、山川、草木、蟲魚、鳥獸，往往有得，以其求思之深而無不在也。夫夷以近，則遊者眾；險以遠，則至者少。而世之奇偉、瑰怪，非常之觀，常在於險遠，而人之所罕至焉，故非有志者不能至也。有志矣，不隨以止也，然力不足者，亦不能至也。有志與力，而又不隨以怠，至於幽暗昏惑而無物以相之，亦不能至也。然力足以至焉，於人為可譏，而在己為有悔；盡吾志也而不能至者，可以無悔矣，其孰能譏之乎？此余之所得也。',
  },

  {
    id: 'classic-xunjianshikang',
    category: 'classic',
    dynasty: 'song',
    title: '訓儉示康（全文）',
    source: '司馬光',
    description: '司馬光訓子崇儉，以古聖賢為榜樣。',
    content: '吾本寒家，世以清白相承。吾性不喜華靡，自為乳兒，長者加以金銀華美之飾，輒去之。及得官，雖為雅俗所譏，然亦終不自改。今人皆以奢靡為務，而吾獨守此儉素。大凡物之可貴者，在於其德，不在於其外飾。夫人之常情，由儉入奢易，由奢入儉難。奢則多欲。君子多欲則貪慕富貴，枉道速禍；小人多欲則多求妄用，敗家喪身。故曰：儉，德之共也；侈，惡之大也。昔正考父饘粥以餬口，孟獻子日用不過數升。古之聖賢，無不以儉素為美德。吾今示汝以此，非徒為省財，實欲汝保此清白家風，不為物欲所役，庶幾可立身於世，無愧於先人也。汝當體此意，深思而力行之。',
  },

  {
    id: 'poem-qing-qiaoxi',
    category: 'poem',
    dynasty: 'song',
    title: '鵲橋仙',
    source: '秦觀',
    description: '秦觀愛情詞，兩情若是長久時，又豈在朝朝暮暮。',
    content: '纖雲弄巧，飛星傳恨，銀漢迢迢暗度。金風玉露一相逢，便勝卻人間無數。柔情似水，佳期如夢，忍顧鵲橋歸路。兩情若是長久時，又豈在朝朝暮暮。',
  },

  {
    id: 'poem-yanlingna',
    category: 'poem',
    dynasty: 'song',
    title: '青玉案·淩波不過橫塘路',
    source: '賀鑄',
    description: '賀鑄愁情詞，「一川煙草，滿城風絮」傳誦千古。',
    content: '淩波不過橫塘路，但目送、芳塵去。錦瑟華年誰與度？月橋花院，瑣窗朱戶，只有春知處。飛雲冉冉蘅皋暮，彩筆新題斷腸句。試問閒愁都幾許？一川煙草，滿城風絮，梅子黃時雨。',
  },

  {
    id: 'classic-huangzhoukuaizaiting',
    category: 'classic',
    dynasty: 'song',
    title: '黃州快哉亭記',
    source: '蘇轍',
    description: '蘇轍記張夢得謫居黃州所築快哉亭，抒發曠達自適之懷。',
    content: '江出西陵，始得平地，其流奔放肆大。南合沅、湘，北合漢、沔，其勢益張。至於赤壁之下，波流浸灌，與海相若。清河張君夢得，謫居齊安，即其廬之西南為亭，以覽觀江流之勝，而余兄子瞻名之曰「快哉」。\n蓋亭之所見，南北百里，東西一舍。濤瀾洶湧，風雲開闔。晝則舟楫出沒於其前，夜則魚龍悲嘯於其下。變化倏忽，動心駭目，不可久視。今乃得玩之几席之上，舉目而足。西望武昌諸山，岡陵起伏，草木行列，煙消日出，漁夫樵父之舍，皆可指數。此其所以為快哉者也。至於長洲之濱，故城之墟，曹孟德、孫仲謀之所睥睨，周瑜、陸遜之所騁騖，其流風遺跡，亦足以稱快世俗。\n昔楚襄王從宋玉、景差於蘭臺之宮，有風颯然至者，王披襟當之曰：「快哉此風！寡人所與庶人共者耶？」宋玉曰：「此獨大王之雄風耳，庶人安得共之？」玉之言蓋有諷焉。夫風無雄雌之異，而人有遇不遇之變。楚王之所以為樂，與庶人之所以為憂，此則人之變也，而風何與焉？士生於世，使其中不自得，將何往而非病？使其中坦然，不以物傷性，將何適而非快？今張君不以謫為患，竊會計之餘功，而自放山水之間，此其中宜有以過人者。將蓬戶甕牖，無所不快，而況乎濯長江之清流，挹西山之白雲，窮耳目之勝以自適也哉！不然，連山絕壑，長林古木，振之以清風，照之以明月，此皆騷人思士之所以悲傷憔悴而不能勝者，烏睹其為快也哉！\n元豐六年十一月朔日，趙郡蘇轍記。',
  },

  {
    id: 'classic-liuhoulun',
    category: 'classic',
    dynasty: 'song',
    title: '留侯論',
    source: '蘇軾',
    description: '蘇軾論張良能忍小憤而就大謀，為天下大勇者。',
    content: '古之所謂豪傑之士者，必有過人之節。人情有所不能忍者，匹夫見辱，拔劍而起，挺身而鬥，此不足為勇也。天下有大勇者，卒然臨之而不驚，無故加之而不怒。此其所挾持者甚大，而其志甚遠也。\n夫子房受書於圯上之老人也，其事甚怪。然亦安知其非秦之世，有隱君子者出而試之？觀其所以微見其意者，皆聖賢相與警戒之義。而世不察，以為鬼物，亦已過矣。且其意不在書。當韓之亡，秦之方盛也，以刀鋸鼎鑊待天下之士。其平居無罪夷滅者，不可勝數。雖有賁、育，無所復施。夫持法太急者，其鋒不可犯，而其勢可乘。子房不忍忿忿之心，以匹夫之力，而逞於一擊之間。當此之時，子房之不死者，其間不能容髮，蓋亦已危矣。千金之子，不死於盜賊。何者？其身之可愛，而盜賊之不足以死也。子房以蓋世之才，不為伊尹、太公之謀，而特出於荊軻、聶政之計，以僥倖於不死。此圯上老人之所為深惜者也。是故倨傲鮮腆而深折之。彼其能有所忍也，然後可以就大事，故曰：「孺子可教也。」\n楚莊王伐鄭，鄭伯肉袒牽羊以逆。莊王曰：「其君能下人，必能信用其民矣。」遂舍之。勾踐之困於會稽，而歸臣妾於吳者，三年而不倦。且夫有報人之志，而不能下人者，是匹夫之剛也。夫老人者，以為子房才有餘，而憂其度量之不足，故深折其少年剛銳之氣，使之忍小忿而就大謀。何則？非有生平之素，卒然相遇於草莽之間，而命以僕妾之役，油然而不怪者，此固秦皇之所不能驚，而項籍之所不能怒也。\n觀夫高祖之所以勝，而項籍之所以敗者，在能忍與不能忍之間而已矣。項籍唯不能忍，是以百戰百勝而輕用其鋒；高祖忍之，養其全鋒而待其弊，此子房教之也。當淮陰破齊而欲自王，高祖發怒，見於詞色。由此觀之，猶有剛強不忍之氣，非子房其誰全之？\n太史公疑子房以為魁梧奇偉，而其狀貌乃如婦人女子，不稱其志氣。嗚呼！此其所以為子房歟！',
  },

  {
    id: 'classic-shizhongshanji',
    category: 'classic',
    dynasty: 'song',
    title: '石鐘山記',
    source: '蘇軾',
    description: '蘇軾夜探石鐘山，實地考證命名由來，寓「事不目見耳聞不可臆斷」之理。',
    content: '水經云：「彭蠡之口有石鐘山焉。」酈元以為下臨深潭，微風鼓浪，水石相搏，聲如洪鐘。是說也，人常疑之。今以鐘磬置水中，雖大風浪不能鳴也，而況石乎！至唐李渤始訪其遺蹤，得雙石於潭上，扣而聆之，南聲函胡，北音清越，桴止響騰，餘韻徐歇。自以為得之矣。然是說也，余尤疑之。石之鏗然有聲者，所在皆是也，而此獨以鐘名，何哉？\n元豐七年六月丁丑，余自齊安舟行適臨汝，而長子邁將赴饒之德興尉，送之至湖口，因得觀所謂石鐘者。寺僧使小童持斧，於亂石間擇其一二扣之，硿硿焉。余固笑而不信也。至莫夜月明，獨與邁乘小舟，至絕壁下。大石側立千尺，如猛獸奇鬼，森然欲搏人。而山上棲鶻，聞人聲亦驚起，磔磔雲霄間。又有若老人欬且笑於山谷中者，或曰：「此鸛鶴也。」余方心動欲還，而大聲發於水上，噌吰如鐘鼓不絕。舟人大恐。徐而察之，則山下皆石穴罅，不知其淺深，微波入焉，涵澹澎湃而為此也。舟迴至兩山間，將入港口，有大石當中流，可坐百人，空中而多竅，與風水相吞吐，有窾坎鏜鞳之聲，與向之噌吰者相應，如樂作焉。因笑謂邁曰：「汝識之乎？噌吰者，周景王之無射也；窾坎鏜鞳者，魏莊子之歌鐘也。古之人不余欺也！」\n事不目見耳聞，而臆斷其有無，可乎？酈元之所見聞，殆與余同，而言之不詳；士大夫終不肯以小舟夜泊絕壁之下，故莫能知；而漁工水師雖知而不能言。此世所以不傳也。而陋者乃以斧斤考擊而求之，自以為得其實。余是以記之，蓋歎酈元之簡，而笑李渤之陋也。',
  },

  {
    id: 'classic-dumengchangjun',
    category: 'classic',
    dynasty: 'song',
    title: '讀孟嘗君傳',
    source: '王安石',
    description: '王安石翻案文章，論孟嘗君僅得雞鳴狗盜之徒，不足以得士。',
    content: '世皆稱孟嘗君能得士，士以故歸之，而卒賴其力以脫於虎豹之秦。嗟乎！孟嘗君特雞鳴狗盜之雄耳，豈足以言得士？不然，擅齊之強，得一士焉，宜可以南面而制秦，尚何取雞鳴狗盜之力哉？雞鳴狗盜之出其門，此士之所以不至也。',
  },

  {
    id: 'calligraphy-sushi-hanshi',
    category: 'calligraphy',
    dynasty: 'song',
    title: '蘇軾·黃州寒食詩帖 (全文)',
    source: '蘇軾',
    description: '天下第三行書，蘇軾貶謫黃州第三年寒食節所作的兩首五言詩，抒發孤獨憂鬱。',
    content: '自我來黃州，已過三寒食。年年欲惜春，春去不容惜。今年又苦雨，兩月秋蕭瑟。臥聞海棠花，泥污胭脂雪。暗中偷負去，夜半真有力。何殊病少年，病起鬚已白。春江欲入戶，雨勢來不已。小屋如漁舟，濛濛水雲裡。空庖煮寒菜，破灶燒濕葦。那知是寒食，但見烏銜紙。君門深九重，墳墓在萬里。也擬哭途窮，死灰吹不起。',
  },

  {
    id: 'calligraphy-huangtingjian-songfeng',
    category: 'calligraphy',
    dynasty: 'song',
    title: '黃庭堅·松風閣詩 (全文)',
    source: '黃庭堅',
    description: '黃庭堅行書大字代表作，筆劃展放，中宮收緊，如虬龍起舞。',
    content: '依山築閣見平川，夜闌箕斗插屋椽。我來喜坐閣下石，風吹松聲如聽泉。黃庭堅遊歷山川，於松風閣下，聽松濤滾滾，如泉水激石。其字行筆遲澀，橫畫長展，縱橫捭闔，意境開闊，盡顯宋代「尚意」書風之妙趣。',
  },

  {
    id: 'calligraphy-mifu-shusu',
    category: 'calligraphy',
    dynasty: 'song',
    title: '米芾·蜀素帖',
    source: '米芾',
    description: '米芾在蜀地織造的素絹上書寫的詩作，用筆俊邁，八面出鋒，動感十足。',
    content: '擬古二首：\n青松勁挺姿，凌霄恥屈盤。種種出枝葉，牽連上松端。\n秋花起絳烟，旖旎雲錦殷。不羞不自立，舒光射丸丸。\n柏見吐子效，鶴疑縮頸還。青松本無華，安得保歲寒？\n龜鶴年壽齊，羽介所託殊。種種是靈物，相得忘形軀。\n鶴有沖霄心，龜厭曳尾居。以竹兩附口，相將上雲衢。\n報汝慎勿語，一語墮泥塗。\n\n吳江垂虹亭作二首：\n斷雲一片洞庭帆，玉破鱸魚金破柑。\n好作新詩繼桑苧，垂虹秋色滿東南。\n泛泛五湖霜氣清，漫漫不辨水天形。\n何須織女支機石，且戲常娥稱客星。\n\n入境寄集賢林舍人：\n時為湖州之行。入境寄集賢林舍人。\n揚帆載月遠相過，佳氣蔥蔥聽誦歌。\n路不拾遺知政肅，野多滯穗是時和。\n天分秋暑資吟興，晴獻溪山入醉哦。\n便捉蟾蜍共研墨，綵牋書盡剪江波。\n\n重九會郡樓：\n山清氣爽九秋天，黃菊紅茱滿泛船。\n千里結言寧有後，群賢畢至猥居前。\n杜郎閑客今焉是，謝守風流古所傳。\n獨把秋英緣底事，老來情味向詩偏。\n\n和林公峴山之作：\n皎皎中天月，團團徑千里。\n震澤乃一水，所占已過二。\n娑羅即峴山，謬云形大地。\n地惟東吳偏，山水古佳麗。\n中有皎皎人，瓊衣玉為餌。\n位維列仙長，學與千年對。\n幽操久獨處，迢迢願招類。\n金颸帶秋威，欻逐雲檣至。\n朝隮輿馭飈，暮返光浮袂。\n雲盲有風駈，蟾餮有刀利。\n亭亭太陰宮，無乃瞻星氣？\n興深夷險一，理洞軒裳偽。\n紛紛夸俗勞，坦坦忘懷易。\n浩浩將我行，蠢蠢須公起。\n\n送王渙之彥舟：\n集英春殿鳴梢歇，神武天臨光下澈。鴻臚初唱第一聲，白面王郎年十八。\n神武樂育天下造，不使敲枰使傳道。衣錦東南第一州，棘璧湖山兩清照。\n襄陽野老漁竿客，不愛紛華愛泉石。相逢不約約無逆，輿握古書同岸幘。\n淫朋嬖黨初相慕，濯髮洒心求易慮。翩翩遼鶴雲中侶，土苴尫鴟那一顧。\n邇來器業何深至，湛湛具區無底沚。可憐一點終不易，枉駕殷勤尋漫仕。\n漫仕平生四方走，多與英才並肩肘。少有俳辭能罵鬼，老學鴟夷漫存口。\n一官聊具三徑資，取捨殊塗莫迴首。',
  },

  {
    id: 'sutra-taishang-ex',
    category: 'sutra',
    dynasty: 'song',
    title: '太上感應篇 (全文)',
    source: '宋·李昌齡 傳',
    description: '道教勸善經典，以「禍福無門，唯人自召」為核心，警示因果報應之理。',
    content: '太上曰：禍福無門，唯人自召；善惡之報，如影隨形。是以天地有司過之神，依人所犯輕重，以奪人算。算減則貧耗，多逢憂患。人皆惡之，刑禍隨之，吉慶避之，惡星災之；算盡則死。夫心起於善，善雖未為，而吉神已隨之；或心起於惡，惡雖未為，而凶神已隨之。其有曾行惡事，後自改悔，諸惡莫作，眾善奉行，久久必獲吉慶，所謂轉禍為福也。夫人欲求天仙者，當立一千三百善；欲求地仙者，當立三百善。一日投善，三德隨之，吉慶自至。故吉人語善、視善、行善，一日有三善，三年天必降之福。凶人語惡、視惡、行惡，一日有三惡，三年天必降之禍。胡不勉力行善，以自求多福哉！',
  },
  {
    id: 'classic-qiushengfu',
    category: 'classic',
    dynasty: 'song',
    title: '秋聲賦',
    source: '歐陽修',
    description: '歐陽修代表作，描寫秋夜聽聞之聲，抒發悲秋之嘆與人事憂勞的感慨。',
    content: '歐陽子方夜讀書，聞有聲自西南來者，悚然而聽之，曰：「異哉！」初淅瀝以蕭颯，忽奔騰而砰湃；如波濤夜驚，風雨驟至。其觸於物也，鏦鏦錚錚，金鐵皆鳴；又如赴敵之兵，銜枚疾走，不聞號令，但聞人馬之行聲。予謂童子：「此何聲也？汝出視之。」童子曰：「星月皎潔，明河在天，四無人聲，聲在樹間。」余曰：「噫嘻，悲哉！此秋聲也，胡為而來哉？蓋夫秋之為狀也：其色慘淡，煙霏雲斂；其容清明，天高日晶；其氣慄冽，砭人肌骨；其意蕭條，山川寂寥。故其為聲也，淒淒切切，呼號憤發。豐草綠縟而爭茂，佳木蔥蘢而可悅；草拂之而色變，木遭之而葉脫；其所以摧敗零落者，乃其一氣之餘烈。夫秋，刑官也，於時為陰；又兵象也，於行為金，是謂天地之義氣，常以肅殺而為心。天之於物，春生秋實。故其在樂也，商聲主西方之音，夷則為七月之律。商，傷也；物既老而悲傷。夷，戮也；物過盛而當殺。嗟乎！草木無情，有時飄零。人為動物，惟物之靈。百憂感其心，萬事勞其形。有動於中，必搖其精。而況思其力之所不及，憂其智之所不能；宜其渥然丹者為槁木，黟然黑者為星星。奈何以非金石之質，欲與草木而爭榮？念誰為之戕賊，亦何恨乎秋聲！童子莫對，垂頭而睡。但聞四壁蟲聲唧唧，如助余之歎息。',
  },
  {
    id: 'classic-jishimanqingwen',
    category: 'classic',
    dynasty: 'song',
    title: '祭石曼卿文',
    source: '歐陽修',
    description: '歐陽修悼念亡友石曼卿的名篇，抒發對好友磊落生平的追懷與生死之悲。',
    content: '維治平四年七月日，具官歐陽修，謹遣尚書都省令史李敭，至於太清，以清酌庶羞之奠，致祭於亡友曼卿之墓下，而弔之以文。曰：嗚呼曼卿！生而為英，死而為靈。其同乎萬物生死，而復歸於無物者，暫聚之形；不與萬物共盡，而卓然其不朽者，後世之名。此自古聖賢，莫不皆然，而著在簡冊者，昭如日星。嗚呼曼卿！吾不見子久矣，猶能仿佛子之平生。其軒昂磊落，突兀崢嶸，而埋藏於地下者，意其不化為朽壤，而為金玉之精。不然，生長松之千尺，產靈芝而九莖。奈何荒煙野蔓，荊棘縱橫；風淒露下，走磷飛螢！但見牧童樵叟，歌吟上下，與夫驚禽駭獸，悲鳴躑躅而咿嚶。今固如此，更千秋而萬歲兮，安知其不穴藏狐貉與鼯鼪？此自古聖賢亦皆然兮，獨不見夫累累乎曠野與荒城！嗚呼曼卿！盛衰之理，吾固知其如此，而感念疇昔，悲涼淒愴，不覺臨風而隕涕者，有愧乎太上之忘情。尚饗！',
  },
  {
    id: 'classic-pengdanglun',
    category: 'classic',
    dynasty: 'song',
    title: '朋黨論',
    source: '歐陽修',
    description: '歐陽修政論代表作，駁斥朋黨之說，辨析君子與小人之黨的本質區別。',
    content: '臣聞朋黨之說，自古有之，惟幸人君辨其君子小人而已。大凡君子與君子，以同道為朋；小人與小人，以同利為朋；此自然之理也。然臣謂小人無朋，惟君子則有之。其故何哉？小人所好者，祿利也；所貪者，財貨也。當其同利之時，暫相黨引以為朋者，偽也；及其見利而爭先，或利盡而交疏，則反相賊害，雖其兄弟親戚，不能相保。故臣謂小人無朋，其暫為朋者，偽也。君子則不然。所守者道義，所行者忠信，所惜者名節。以之修身，則同道而相益；以之事國，則同心而共濟，終始如一，此君子之朋也。故為人君者，但當退小人之偽朋，用君子之真朋，則天下治矣。堯之時，小人共工、驩兜等四人為一朋，君子八元、八愷十六人為一朋。舜佐堯，退四凶小人之朋，而進元、愷君子之朋，堯之天下大治。及舜自為天子，而皋、夔、稷、契等二十二人，並列於朝，更相稱美，更相推讓，凡二十二人為一朋，而舜皆用之，天下亦大治。《書》曰：「紂有臣億萬，惟億萬心；周有臣三千，惟一心。」紂之時，億萬人各異心，可謂不為朋矣，然紂以亡國。周武王之臣，三千人為一大朋，而周用以興。後漢獻帝時，盡取天下名士囚禁之，目為黨人；及黃巾賊起，漢室大亂，後方悔悟，盡解黨人而釋之，然已無救矣。唐之晚年，漸起朋黨之論。及昭宗時，盡殺朝之名士，或投之黃河，曰：「此輩清流，可投濁流。」而唐遂亡矣。夫前世之主，能使人人異心不為朋，莫如紂；能禁絕善人為朋，莫如漢獻帝；能誅戮清流之朋，莫如唐昭宗之世；然皆亂亡其國。更相稱美、推讓而不自疑，莫如舜之二十二臣，舜亦不疑而皆用之；然而後世不誚舜為二十二人朋黨所欺，而稱舜為聰明之聖者，以能辨君子與小人也。周武之世，舉其國之臣三千人共為一朋。自古為朋之多且大，莫如周；然周用此以興者，善人雖多而不厭也。夫興亡治亂之跡，為人君者，可以鑒矣。',
  },
  {
    id: 'classic-wudaishilingguanzhuanxu',
    category: 'classic',
    dynasty: 'song',
    title: '五代史伶官傳序',
    source: '歐陽修',
    description: '歐陽修史論名作，分析後唐莊宗盛衰得失，論證「憂勞可以興國，逸豫可以亡身」。',
    content: '嗚呼！盛衰之理，雖曰天命，豈非人事哉！原莊宗之所以得天下，與其所之失之者，可以知之矣。世言晉王之將終也，以三矢賜莊宗，而告之曰：「梁，吾仇也；燕王，吾所立；契丹，與吾約為兄弟；而皆背晉以歸梁。此三者，吾遺恨也。與爾三矢，爾其無忘乃父之志！」莊宗受而藏之於廟。其後用兵，則遣從事以一少牢告廟，請其矢，盛以錦囊，負而前驅，及凱旋而納之。方其係燕父子以組，函梁君臣之首，入於太廟，還矢先王，而告以成功，其意氣之盛，可謂壯哉！及仇讎已滅，天下已定，一夫夜呼，亂者四應，倉皇東出，未及見賊而士卒離散，君臣相顧，不知所歸。至於誓天斷髮，泣下沾襟，何其衰也！豈得之難而失之易歟？抑本其成敗之跡，而皆自於人歟？《書》曰：「滿招損，謙受益。」憂勞可以興國，逸豫可以亡身，自然之理也。故方其盛也，舉天下之豪傑，莫能與之爭；及其衰也，數十伶人困之，而身死國滅，為天下笑。夫禍患常積於忽微，而智勇多困於所溺，豈獨伶人也哉！作《伶官傳》。',
  },
  {
    id: 'classic-fengletingji',
    category: 'classic',
    dynasty: 'song',
    title: '豐樂亭記',
    source: '歐陽修',
    description: '歐陽修減滁州時所作，描繪豐樂亭景色，表達安閒治郡與民同樂的情懷。',
    content: '修既治滁之明年，夏，始飲滁水而甘。問諸滁人，得於州南百步之遠。其上則豐山，聳然而特立；下則幽谷，窈然而深藏；中有清泉，滃然而仰出。俯仰左右，顧而樂之。於是疏泉鑿石，闢地以為亭，而與滁人往遊其間。滁於五代干戈之際，用武之地也。昔太祖皇帝，嘗以周師破李景兵十五萬於清流山下，生擒其將皇甫暉、姚鳳於滁東門之外，遂以平滁。修嘗考其山川，按其圖記，升高以望清流之關，欲求暉、鳳就擒之所，而故老皆無在者，蓋天下之平久矣。自唐失其政，海內分裂，豪傑並起而爭，所在為敵國者，何可勝數？及宋受天命，聖人出而四海一。向之憑恃險阻，鏟削消磨，百年之間，漠然徒見山高而水清。欲問其事，而遺老盡矣！今滁介江淮之間，舟車商賈、四方賓客之所不至，民生不見外事，而安於畎畝衣食，以樂生送死。而孰知上之功德，休養生息，涵煦於百年之深也！修之來此，樂其地僻而事簡，又愛其俗之安閒。既得斯泉於山谷之間，乃日與滁人仰而望山，俯而聽泉，掇幽芳而蔭喬木，風霜冰雪，刻露清秀，四時之景，無不可愛。又幸其民樂其歲物之豐成，而喜與予遊也。因為本其山川，道其風俗之美，使民知所以安此豐年之樂者，幸生無事之時也。夫宣上恩德，以與民共樂，刺史之事也。遂書以名其亭焉。',
  },
  {
    id: 'poem-ouyang-shengzhazi',
    category: 'poem',
    dynasty: 'song',
    title: '生查子·元夕',
    source: '歐陽修',
    description: '歐陽修經典元宵詞，抒發物是人非的哀婉相思。',
    content: '去年元夜時，花市燈如晝。月上柳梢頭，人約黃昏後。今年元夜時，月與燈依舊。不見去年人，淚濕春衫袖。',
  },
  {
    id: 'poem-ouyang-dielianhua',
    category: 'poem',
    dynasty: 'song',
    title: '蝶戀花·庭院深深深幾許',
    source: '歐陽修',
    description: '歐陽修傷春閨怨詞代表作，意境深婉，名句「淚眼問花花不語」。',
    content: '庭院深深深幾許，楊柳堆煙，簾幕無重數。玉勒雕鞍遊冶處，樓高不見章臺路。雨橫風狂三月暮，門掩黃昏，無計留春住。淚眼問花花不語，亂紅飛過鞦韆去。',
  },
  {
    id: 'poem-ouyang-tashaxing',
    category: 'poem',
    dynasty: 'song',
    title: '踏莎行·候館梅殘',
    source: '歐陽修',
    description: '歐陽修經典遊子閨思詞，將離愁寫到「春山外」，空間無限。',
    content: '候館梅殘，溪橋柳細，草薰風暖搖征轡。離愁漸遠漸無窮，迢迢不斷如春水。寸寸柔腸，盈盈粉淚，樓高莫近危欄倚。平蕪盡處是春山，行人更在春山外。',
  },
  {
    id: 'classic-meishenyushijixu',
    category: 'classic',
    dynasty: 'song',
    title: '梅聖俞詩集序',
    source: '歐陽修',
    description: '歐陽修為梅堯臣詩集所作之序，提出著名詩學觀點「窮者而後工」。',
    content: '予聞世謂詩人，少達而多窮，夫豈然哉！蓋世所傳詩者，多出於古窮人之辭也。凡士之蘊其所有，而不得施於世者，多喜自放於山巔水涯之外，見蟲魚草木風雲鳥獸之狀類，往往探其奇怪。內有憂思感憤之鬱積，其興於怨刺，以道羈臣寡婦之所歎，而寫人情之難言，蓋愈窮而愈工。然則非詩之能窮人，殆窮者而後工也。予友梅聖俞，少以蔭補為吏，累舉進士，輒抑於有司，困於州縣，凡十餘年。年今五十，猶從辟書，為人之佐。鬱其所蓄，不得奮見於事業。其家宛陵，幼習於詩。自為童子，出語已驚其長老。既長，學乎六經仁義之說。其為文章，簡古純粹，不求苟說於世。世之人，徒知其詩而已。然時無賢愚，語詩者必求之聖俞。聖俞亦自以其不得志者，樂於詩而發之。故其平生所作，於詩尤多。世既知之矣，而未有薦於上者。昔王文康公嘗見而歎曰：「二百年無此作矣！」雖知之深，亦不果薦也。若使其幸得用於朝廷，作為雅、頌，以歌詠大宋之功德，薦之清廟，而追商、周、魯頌之作者，豈不偉歟！奈何使其老不得志，而為窮者之詩，乃徒發於蟲魚物類，羈愁感嘆之言。世徒喜其工，不知其窮之久而將老也！可不惜哉！聖俞詩既多，不自收拾。其妻之兄子謝景初，懼其多而易失也，取其自洛陽至於吳興以來所作，次為十卷。予嘗嗜聖俞詩，而患不能盡得之，遽喜謝氏之能類次也，輒序而藏之。其後十五年，聖俞以疾卒於京師，餘既哭而銘之，因索於其家，得其遺稿千餘篇，並舊所藏，掇其尤者六百七十七篇，為一十五卷。嗚呼！吾於聖俞詩論之詳矣，故不復云。',
  },
  {
    id: 'classic-songxuwudangnanguixu',
    category: 'classic',
    dynasty: 'song',
    title: '送徐無黨南歸序',
    source: '歐陽修',
    description: '歐陽修送弟子徐無黨南歸之序，探討「修身、施政、立言」的不朽關係。',
    content: '草木鳥獸之為物，眾人之為人，其為生雖異，而為死則同，一歸於腐壞、澌盡、泯滅而已。而眾人之中，有聖賢者，固亦生且死於其間，而獨異於草木、鳥獸、眾人者，雖死而不朽，逾遠而彌存也。其所以為聖賢者，修之於身，施之於事，見之於言，是三者所以能不朽而存也。修於身者，無所不獲；施於事者，有得有不得焉；其見於言者，則又有能有不能也。施於事矣，不見於言可也。自《詩》、《書》、《史記》所傳，其人豈必皆能言之士哉？修於身矣，而不施於事，不見於言，亦可也。孔子弟子，有能政事者矣，有能言語者矣。若顏回者，在陋巷，曲肱饑臥而已，其群居則默然終日如愚人。然自當時群弟子皆推尊之，以為不敢望而及。而後世更百千歲，亦未有能及之者。其不朽而存者，固不待施於事，況於言乎？予讀班固《藝文志》、唐《四庫書目》，見其所列，自三代、秦、漢以來，著書之士，多者至百餘篇，少者猶三、四十篇；其人不可勝數，而散亡磨滅，百不一二存焉。予竊悲其人，文章麗矣，言語工矣，無異草木榮華之飄風，鳥獸好音之過耳也。方其用心與力之勞，亦何異眾人之汲汲營營，而忽焉以死者，雖有遲有速，而卒與三者同歸於泯滅。夫言之不可恃也蓋如此。今之學者，莫不慕古聖賢之不朽，而勤一世以盡心於文字間者，皆可悲也！東陽徐生，少從予學為文章，稍稍見稱於人。既去，而與群士試於禮部，得高第，由是知名。其文辭日進，如水湧而山出。予欲摧其盛氣而勉其思也，故於其歸，告以是言。然予固亦喜為文辭者，亦因以自警焉。',
  },
  {
    id: 'classic-bianjianlun',
    category: 'classic',
    dynasty: 'song',
    title: '辨奸論',
    source: '蘇洵',
    description: '蘇洵辨識奸臣的名篇，主張透過日常細微言行洞察奸邪之人的本質。',
    content: '事有必至，理有固然。惟天下之靜者，乃能見微而知著。月暈而風，礎潤而雨，人人知之。人事之推移，理勢之相因，其疎闊而難知，變化而不可測者，孰與天地陰陽之事？而賢者有不知，其故何也？好惡亂其中，而利害奪其外也。今有人，口誦孔、孟之賢言，身履規矩之正行，曾不若旁人之惑，捷捷然以自異於眾人。為其同之也，難；為其獨之也，易。其衣臣虜之衣，食犬彘之食，囚首喪面而談詩書，此豈其情也哉？凡人情之所急者，名利也。今捨此而獨為是，是以小事欺人，而以大事售其奸也。彼其外之清，所以掩其內之濁；其外之同，所以售其內之異。昔者，豎刁、易牙、開方，三子之所以相齊桓公，其為天下之大惡，非有他術也，特其情與人異耳。人莫不愛其身，而刁自割其身；人莫不愛其子，而牙蒸其子；人莫不愛其親，而開方捨其親。此三子者，非無人性也，為大奸以欺人，而人不知也。桓公不寤，死於其手，五子爭立，齊國大亂。夫天下之奸人，必有非常之行以惑世。夫以衣食、容貌之不若人，為聖人、賢者之行，此其情且猶不可，而況其終耶？吾見其外，而知其內之不然；吾見其始，而知其終之必至於此也。夫天下之治，其政平，其刑清，其君子皆自愛，其小人皆畏法，則天下何自而亂？惟其非常之行，起而亂其中，然後天下之大奸，得乘其隙以售其謀。今有人，見微而知著，知其終之必至於此也。夫為人子而不知孝，為人臣而不知忠，其心已不可問，而又為非常之行，是必有所大欲也。夫古之賢人，如管仲、諸葛孔明，其言動、衣冠、居處，皆與人同。是以人樂與之處，而不知其有異也。今此人自異於眾人，是必有以大異於眾人者。吾是以辨之。',
  },
  {
    id: 'classic-xinshu',
    category: 'classic',
    dynasty: 'song',
    title: '心術',
    source: '蘇洵',
    description: '蘇洵軍事名論，闡述為將者在治心、用兵、義怒、將戰等方面的基本素養與原則。',
    content: '為將之道，當先治心。泰山崩於前而色不變，麋鹿興於左而目不瞬，然後可以制利害，可以待敵。凡兵上義；不義，雖利勿動。非一動之為利害，而他日將有所不可措手足也。夫惟義可以怒士，士以義怒，可與百戰。凡戰之道，未戰養其財，將戰養其力，既戰養其氣，既勝養其心。將驍勇則士不戰而自氣，將深沉則士不躁而自實。',
  },
  {
    id: 'classic-guanzhonglun',
    category: 'classic',
    dynasty: 'song',
    title: '管仲論',
    source: '蘇洵',
    description: '蘇洵政治史論，分析管仲死後齊國衰亡之因，論述局勢防範。',
    content: '管仲相桓公，霸諸侯，攘戎狄，終其身齊國富強，諸侯不叛。管仲死，豎刁、易牙、開方用。桓公薨於亂，五公子爭立，其禍蔓延，訖簡公，齊無寧歲。夫功之成，非成於成之日，蓋必有所由起；禍之作，不作於作之日，亦必有所由兆。故齊之治也，吾不曰管仲之治，而曰桓公之治；其亂也，吾不曰三子之亂，而曰桓公之亂。何則？管仲之能賢三子，此天下之所知也；而桓公之能用管仲與三子，此管仲之所不及知也。夫管仲死，三子用，此齊國之所以亂也。然使管仲不死，齊國其庶幾乎？吾曰：管仲死，而齊國之亂已兆於管仲之生也。管仲病，桓公問曰：「群臣誰可相者？」管仲對曰：「知臣莫若君。」公曰：「易牙何如？」對曰：「殺子以適君，非人情，不可。」公曰：「開方何如？」對曰：「倍親以事君，非人情，難近。」公曰：「豎刁何如？」對曰：「自宮以事君，非人情，難愛。」管仲死，桓公皆用之，卒受其禍。',
  },
  {
    id: 'classic-mingerzishuo',
    category: 'classic',
    dynasty: 'song',
    title: '名二子說',
    source: '蘇洵',
    description: '蘇洵為兒子蘇軾與蘇轍取名所寫的名篇，勉勵二子各依其名，立身處世。',
    content: '輪輻蓋軫，皆有職乎車，而軾獨若無所為者。雖然，去軾則吾未見其為完車也。軾乎，吾懼汝之不外飾也。天下之車莫不由轍，而言車之功者，轍不與焉。雖然，車僕馬斃而患亦不及轍。是轍者，善處乎禍福之間也。轍乎，吾知免矣。',
  },
  {
    id: 'classic-shanghanshumishu',
    category: 'classic',
    dynasty: 'song',
    title: '上韓樞密書',
    source: '蘇洵',
    description: '蘇洵呈給韓琦的自薦信，陳述自己研究古代興衰成敗、深曉兵法大義的抱負。',
    content: '太尉執事：洵著書無他長，及言兵事，論古今形勢，至自比賈誼。所獻《權書》，雖古人已往成敗之跡，苟深曉其義，施之於今，無所不可。古之善言兵者，莫如孫武。武之書十萬言，其指要不出乎「避實擊虛」四字。武之兵，可謂神矣。然其書本於權謀，而未及乎大義。洵之書，則必本於大義，而參之以權謀。故其言雖奇，而不悖於理；其術雖變，而不離於正。太尉苟以為可教而辱教之，又幸矣。',
  },
  {
    id: 'classic-songshichangyanshibeiyin',
    category: 'classic',
    dynasty: 'song',
    title: '送石昌言使北引',
    source: '蘇洵',
    description: '蘇洵送別同鄉好友石昌言出使契丹的贈言，回顧兩家深厚交情與離別寄望。',
    content: '昌言舉進士時，吾始數歲，未學也。憶與群兒戲先府君側，昌言從旁取棗栗啖我，家居相近，又以親戚故，甚狎。昌言及第，在京師，久不歸。後十餘年，吾始亦舉進士，復相見。昌言已老，而吾亦衰矣。今昌言以才略器識，奉天子命，將使於北。北人多豪傑之士，聞昌言至，必且延見，議論大計。吾雖老且病，不能從昌言於北，然幸得送之。遂書以贈之。',
  },
  {
    id: 'classic-zhangyizhouhuaxiangji',
    category: 'classic',
    dynasty: 'song',
    title: '張益州畫像記',
    source: '蘇洵',
    description: '蘇洵記張方平治理蜀地的政績，讚美其在邊境警報時臨危不亂、鎮撫人民。',
    content: '至和元年秋，蜀人傳言有寇至，邊軍夜呼，野無居人，謠言流聞，京師震驚。方命擇帥，天子曰：「毋養亂，毋助變。眾言朋興，朕志自定。」乃命張公以禮部侍郎知成都府。公至，不改常法，不作威嚴，理訟折獄，皆以誠信。未幾，人心大定，寇亦不至。蜀人感公之德，畫公之像而祀之。洵嘗觀公之為政，寬而不弛，嚴而不猛，真可謂善治蜀者也。',
  },
  {
    id: 'classic-xiangjilun',
    category: 'classic',
    dynasty: 'song',
    title: '項籍論',
    source: '蘇洵',
    description: '蘇洵論項籍、曹操與劉備在取天下時的才、慮、量之對比。',
    content: '吾嘗論項籍有取天下之才，而無取天下之慮；曹操有取天下之慮，而無取天下之量；玄德有取天下之量，而無取天下之才。故三人者，終其身無成焉。夫取天下者，必兼此三者，而後可。項籍恃其勇力，以蹂躪天下，而不知理天下之道，是以雖霸一時，而終歸於亡。曹操雖有智慮，而猜忌多疑，不能容賢士，是以終其身不能混一海內。玄德雖有大度，能得人心，而智短才疏，不能與曹氏相抗，是以困於巴蜀。嗚呼！此三人者，皆一時之雄，而其成敗之跡，足為後世之鑒矣。',
  },
  {
    id: 'classic-gaozulun',
    category: 'classic',
    dynasty: 'song',
    title: '高祖論',
    source: '蘇洵',
    description: '蘇洵史論名作，剖析漢高祖以不才取人、制勝項羽的智慧與謀略。',
    content: '漢高祖挾數用術，以制一時之利害，不如陳平；揣摩天下之勢，舉指搖目，以刦制項羽，不如張良。微此二人，則天下不歸漢，而高帝乃木強之人而止耳。然高帝能用此二人，而項羽不能用范增，此漢之所以興，而楚之所以亡也。夫能用人者，無敵於天下。高帝雖無他長，然能折節從人，聽納奇計，是以能集天下之賢，以就大業。項羽雖有拔山之勇，而自專己意，不用賢才，是以雖百戰百勝，而卒歸於滅亡。此用人與不用人之效也。',
  },
  {
    id: 'classic-bingzhi',
    category: 'classic',
    dynasty: 'song',
    title: '兵制',
    source: '蘇洵',
    description: '蘇洵探討三代兵民合一與後代兵民分離的弊端，分析國家軍事體制。',
    content: '三代之時，舉天下之民皆兵也。兵民之分，自秦、漢始。三代之時，聞有諸侯抗天子之命矣，未聞有卒吏叫呼衡行者也。秦、漢以來，諸侯之患不減於三代，而御卒伍者乃如畜虎豹，圈檻一缺，咆哮四出。其故何也？三代之兵耕而食，蠶而衣，故勞，勞則善心生。秦、漢以來，所謂兵者，皆坐而衣食於縣官，故驕，驕則無所不為。三代之兵皆齊民，老幼相養，疾病相救，出相禮讓，入相慈孝，有憂相吊，有喜相慶，其風俗優柔而和易，故其兵畏法而自重。秦、漢以來號齊民者，比之三代既已薄矣，況其所謂兵者，乃其齊民之中尤為兇悍桀黠者也，故常慢法而自棄。',
  },
  {
    id: 'classic-jichengtianshiyeyou',
    category: 'classic',
    dynasty: 'song',
    title: '記承天寺夜遊',
    source: '蘇軾',
    description: '蘇軾著名的隨筆名篇，描寫月夜尋友同遊之景，抒發超然閒適的心境。',
    content: '元豐六年十月十二日夜，解衣欲睡，月色入戶，欣然起行。念無與為樂者，遂至承天寺尋張懷民。懷民亦未寢，相與步於中庭。庭下如積水空明，水中藻、荇交橫，蓋竹柏影也。何夜無月？何處無竹柏？但少閒人如吾兩人者耳。',
  },
  {
    id: 'classic-wenyukeahuayundanggu',
    category: 'classic',
    dynasty: 'song',
    title: '文與可畫筼筜谷偃竹記',
    source: '蘇軾',
    description: '蘇軾悼念表兄文與可的名作，記述其「胸有成竹」的畫論，抒發痛失知己的哀思。',
    content: '竹之始生，一寸之萌耳，而節葉具焉。自蜩腹蛇蚹以至於劍拔十尋者，生而有之也。今畫者乃節節而為之，葉葉而累之，豈復有竹乎！故畫竹必先得成竹於胸中，執筆熟視，乃見其所欲畫者，急起從之，振筆直遂，以追其所見，如兔起鶻落，少縱則逝矣。與可之教予如此。予不能然也，而心識其所以然。夫既心識其所以然而不能然者，內外不一，心手不相應，不學之過也。故凡有見於中而操之不熟者，平居自視了然，而臨事忽焉喪之，豈獨竹乎！',
  },
  {
    id: 'classic-chaozhouhanwengongmiaobei',
    category: 'classic',
    dynasty: 'song',
    title: '潮州韓文公廟碑',
    source: '蘇軾',
    description: '蘇軾撰寫的韓愈廟碑文，盛讚其「文起八代之衰，而道濟天下之溺」的浩然之氣。',
    content: '匹夫而為百世師，一言而為天下法。是皆有以參天地之化，關盛衰之運。其生也，有自來；其逝也，有所為。故申、呂自嶽降，傅說為列星，古今所傳，不可誣也。孟子曰：「吾善養吾浩然之氣。」是氣也，寓於尋常之中，而塞乎天地之間。卒然遇之，則王公失其貴，晉、楚失其富，良、平失其智，賁、育失其勇，儀、秦失其辯。是孰使之然哉？其必有不依形而立，不恃力而行，不待生而存，不隨死而亡者矣。故在天為星辰，在地為河嶽。幽則為鬼神，而明則復為人。此理之常，無足怪者。自東漢以來，道喪文弊，異端並起，歷唐貞觀、開元之盛，輔以房、杜、姚、宋而不能救。獨韓文公起布衣，談笑而麾之，天下靡然從公，復歸於正，蓋三百年於此矣。文起八代之衰，而道濟天下之溺，忠犯人主之怒，勇奪三軍之帥。豈非參天地，關盛衰，浩然而獨存者乎？',
  },
  {
    id: 'classic-chaorantaiji',
    category: 'classic',
    dynasty: 'song',
    title: '超然台記',
    source: '蘇軾',
    description: '蘇軾著名的記體散文，闡明「無所往而不樂」的超然的人生哲學。',
    content: '凡物，皆有可觀。苟有可觀，皆有可樂，非必怪奇瑋麗者也。餔糟啜醨，皆可以醉；果蔬草木，皆可以飽。推此類也，吾安往而不樂？夫所謂求福而辭禍者，以福可喜，而禍可悲也。人之所欲無窮，而物之可以足吾欲者有盡。美惡之辨戰於中，而去取之擇交乎前，則可樂者常少，而可悲者常多，是謂求禍而辭福。夫求禍而辭福，豈人之情也哉？物有以蓋之矣。彼遊於物之內，而不遊於物之外。物非有大小也，自其內而觀之，未有不高且大者也。彼挾其高大以臨我，則我常眩亂反覆，如隙中之觀鬥，又烏知勝負之所在？是以美惡橫生，而憂樂出焉。可不大哀乎！余自錢塘移守膠西，釋舟楫之安，而服車馬之勞；去雕牆之美，而蔽采椽之居；背湖山之觀，而適桑麻之野。始至之日，歲比不登，盜賊滿野，獄訟充斥，而齋廚索然，日食杞菊，人固疑余之不樂也。處之期年，而貌加豐，髮之白者，日以反黑。余既樂其風俗之淳，而其吏民亦安予之拙也。',
  },
  {
    id: 'classic-fangshanzizhuan',
    category: 'classic',
    dynasty: 'song',
    title: '方山子傳',
    source: '蘇軾',
    description: '蘇軾為隱士好友陳慥所作的傳記，描寫其棄家財與勳閥、隱居穷山的高潔心志。',
    content: '方山子，光、黃間隱人也。少時，慕朱家、郭解為人，閭里之俠皆宗之。稍壯，折節讀書，欲以此馳騁當世，然終不遇。晚乃遯於光、黃間，曰岐亭。庵居蔬食，不與世相聞，棄車馬，毀冠服，徒步往來，山中人莫識也。見其所著帽，方聳而高，曰：「此豈古方山冠之遺像乎？」因謂之方山子。余遊於黃，過岐亭，適見焉，曰：「嗚呼，此吾故人陳慥季常也，何為而在此？」方山子亦矍然，問余所以至此者，余告之故。俯而不答，仰而笑，呼余宿其家。環堵蕭然，而妻子奴婢，皆有自得之意；余既聳然異之。',
  },
  {
    id: 'classic-xiyutingji',
    category: 'classic',
    dynasty: 'song',
    title: '喜雨亭記',
    source: '蘇軾',
    description: '蘇軾名篇，記修築亭舍與天降甘霖的喜悅，表達關懷民生與為政之樂。',
    content: '亭以雨名，志喜也。古者有喜，則以名物，示不忘也。周公得禾，以名其書；漢武得鼎，以名其年；叔孫勝敵，以名其子。其喜之大小不齊，其示不忘一也。予至扶風之明年，始治官舍，為亭於堂之北，而鑿池其南，引流種木，以為休息之所。是歲之春，雨麥於岐山之陽，其占為有年。既而彌月不雨，民方以為憂。越三月，乙卯乃雨，甲子又雨，民以為未足；丁卯大雨，三日乃止。官吏相與慶於庭，商賈相與歌於市，農夫相與忭於野；憂者以喜，病者以愈，而吾亭適成。',
  },
  {
    id: 'poem-busuanzihuangzhou',
    category: 'poem',
    dynasty: 'song',
    title: '卜算子·黃州定慧院寓居作',
    source: '蘇軾',
    description: '蘇軾謫居黃州時的孤憤之詞，以孤鴻自況，展現孤高潔淨的操守。',
    content: '缺月掛疏桐，漏斷人初靜。誰見幽人獨往來，縹緲孤鴻影。驚起卻回頭，有恨無人省。揀盡寒枝不肯棲，寂寞沙洲冷。',
  },
  {
    id: 'poem-xijiangyueshishi',
    category: 'poem',
    dynasty: 'song',
    title: '西江月·世事一場大夢',
    source: '蘇軾',
    description: '蘇軾感懷詞，藉中秋賞月抒發世事無常、人生如夢之悲涼。',
    content: '世事一場大夢，人生幾度新涼？夜來風葉已鳴廊，看取眉頭鬢上。酒賤常愁客少，月明多被雲妨。中秋誰與共孤光，把盞悽然北望。',
  },
  {
    id: 'poem-linjiangxianyegui',
    category: 'poem',
    dynasty: 'song',
    title: '臨江仙·夜歸臨皋',
    source: '蘇軾',
    description: '蘇軾謫居黃州時所作，描寫夜半歸家臨江聽濤，流露超然物外的隱逸情懷。',
    content: '夜飲東坡醒復醉，歸來彷彿三更。家童鼻息已雷鳴。敲門都不應，倚杖聽江聲。長恨此身非我有，何時忘卻營營？夜闌風靜縠紋平。小舟從此逝，江海寄餘生。',
  },
  {
    id: 'poem-hedongchuanliubie',
    category: 'poem',
    dynasty: 'song',
    title: '和董傳留別',
    source: '蘇軾',
    description: '蘇軾送別好友董傳的詩作，讚頌讀書人內在的學養，名句「腹有詩書氣自華」。',
    content: '粗繒大布裹生涯，腹有詩書氣自華。厭伴老儒烹瓠葉，強隨舉子踏槐花。囊空不辦尋春馬，眼亂行看擇婿車。得意猶堪誇世俗，詔黃新濕字如鴉。',
  },
  {
    id: 'classic-shangshumihantaiweishu',
    category: 'classic',
    dynasty: 'song',
    title: '上樞密韓太尉書',
    source: '蘇轍',
    description: '蘇轍求見宰相韓琦的自薦信，提出「文以氣為主」的養氣理論。',
    content: '太尉執事：轍生好為文，思之至深。以為文者氣之所形，然文不可以學而能，氣可以養而致。孟子曰：「我善養吾浩然之氣。」今觀其文章，寬厚宏博，充乎天地之間，稱其氣之小大。太史公行天下，周覽四海名山大川，與燕、趙間豪俊交遊，故其文疏蕩，頗有奇氣。此二子者，豈嘗執筆學為如此之文哉？其氣充乎其中而溢乎其貌，動乎其言而見乎其文，而不自知也。',
  },
  {
    id: 'classic-mozhufu',
    category: 'classic',
    dynasty: 'song',
    title: '墨竹賦',
    source: '蘇轍',
    description: '蘇轍著名的賦作，讚美文與可筆下墨竹的神妙，探討藝術與道的統一。',
    content: '與可以墨為竹，視之良竹也。客見而驚焉，曰：「今夫受命於天，賦形於地，涵濡雨露，振蕩風氣，春而萌芽，夏而解馳，散柯布葉，逮冬而遂。性剛潔而疏直，姿嬋娟以閑媚。涉寒暑之徂變，傲冰雪之凌厲。均一氣於草木，嗟壤同而性異。信物生之自然，雖造化其能使。今子研青松之煤，運脫兔之毫，睥睨牆堵，振灑繒綃，須臾而成。與可聽然而笑曰：夫予之所好者道也，放乎竹矣。',
  },
  {
    id: 'classic-sanguolun',
    category: 'classic',
    dynasty: 'song',
    title: '三國論',
    source: '蘇轍',
    description: '蘇轍分析曹操、孫權、劉備的才智得失，論述「以不才取人」的致勝之道。',
    content: '天下皆怯而獨勇，則勇者勝；皆暗而獨智，則智者勝。勇而遇勇，則勇者不足恃也；智而遇智，則智者不足用也。夫唯智勇之不足以定天下，是以天下之難，蜂起而難平。蓋嘗聞之，古者英雄之君，其遇智勇也，以不智不勇，而後真智大勇乃可得而見也。漢高祖、唐太宗，是以智勇獨過天下而得之者也；曹公、孫、劉是以智勇相遇而失之者也。以智攻智，以勇擊勇，此譬如兩虎相捽，齒牙氣力，無以相勝，其勢足以相擾，而不足以相斃。',
  },
  {
    id: 'classic-dongxuanji',
    category: 'classic',
    dynasty: 'song',
    title: '東軒記',
    source: '蘇轍',
    description: '蘇轍謫居監鹽酒稅時所作，回顧為學之志與甘於貧賤的修身感悟。',
    content: '余既以罪謫監筠州鹽酒稅，未至，大雨。鹽酒稅治舍，舊以三吏共事，余至，其二人者，適皆罷去，事委於一。晝則坐市區鬻鹽、沽酒，稅豚魚，與市人爭尋尺以自效；莫歸，筋力疲廢，輒昏然就睡，不知夜之既旦。余昔少年讀書，竊嘗怪顏子簞食瓢飲，居於陋巷，人不堪其憂，顏子不改其樂。及來筠州，勤勞鹽米之間，無一日之休。雖欲棄塵垢，解羈縶，自放於道德之場，而事每劫而留之，然後知顏子之所以甘心貧賤，不肯求斗升之祿以自給者，良以其害於學故也。',
  },
  {
    id: 'classic-wuchangjiuqutingji',
    category: 'classic',
    dynasty: 'song',
    title: '武昌九曲亭記',
    source: '蘇轍',
    description: '蘇轍記錄其兄蘇軾遊歷西山、修築九曲亭的事跡，寄託悠然自適的情懷。',
    content: '子瞻遷於齊安，廬於江上。齊安無名山，而江之南武昌諸山，陂陁蔓延，澗谷深密。依山臨壑，隱蔽松櫪，蕭然絕俗，車馬之跡不至。每風止日出，江水伏息，子瞻杖策載酒，乘漁舟亂流而南。山中有二三子，好客而喜遊，聞子瞻至，幅巾迎笑，相攜徜徉而上，窮山之深，力極而息，掃葉席草，酌酒相勞，意適忘反，往往留宿於山上。亭成，而西山之勝始具，子瞻於是最樂。',
  },
  {
    id: 'classic-suzhe-liuguolun',
    category: 'classic',
    dynasty: 'song',
    title: '六國論',
    source: '蘇轍',
    description: '蘇轍政論名作，從地理形勢剖析六國之亡，指出未能團結庇護韓魏的戰略失策。',
    content: '嘗讀六國世家，竊怪天下之諸侯，以五倍之地，十倍之眾，發憤西向，以攻山西千里之秦，而不免於滅亡，常為之深思遠慮，以為必有可以自安之計。蓋未嘗不咎其當時之士，慮患之疏，而見利之淺，且不知天下之勢也。夫韓魏，秦之衝也。使五國能以四國之力庇護韓魏以禦秦，則秦無自而入。而五國惜韓魏之急，使秦人得以逐個擊破，是以亡也。',
  },
  {
    id: 'classic-suzhe-mengzilun',
    category: 'classic',
    dynasty: 'song',
    title: '孟子論',
    source: '蘇轍',
    description: '蘇轍對孟子為人的評價，讚揚其學說始於至粗、極於至精的義理之美。',
    content: '天下之學者，皆憂孟子之難學，而不知孟子之易入；皆病孟子之言深，而不知其言之至易明也。夫孟子之道，始於至粗，而極於至精。充乎天地，放乎四海。古之學者，非有聖人之資，未易以入其門。然其言往來曲折，以求合於人心，寬厚宏博，使人讀之如飲醇醪，不知其醉。其所以推衍義理，辨析是非，毫釐之差，皆有法度。故學者循其言以求其意，則可以一日而臻於聖人之域。',
  },
  {
    id: 'classic-chaoguzhuan',
    category: 'classic',
    dynasty: 'song',
    title: '巢谷傳',
    source: '蘇轍',
    description: '蘇轍為同鄉俠義之人巢谷寫的傳記，述其俠肝義膽與蘇氏兄弟一生患難真情。',
    content: '巢谷，字元修。父中世，眉山農家也。少從士大夫讀書，老為里校師。谷幼傳父學，雖樸而博。舉進士京師，見舉武藝者，心好之。谷素多力，遂棄其舊學，畜弓箭，習騎射。及蘇氏兄弟落難貶謫，谷徒步萬里以相尋，病卒於旅途。其為人信義篤守，終始不渝，真一代奇士也。',
  },
  {
    id: 'classic-yilaozhaiji',
    category: 'classic',
    dynasty: 'song',
    title: '遺老齋記',
    source: '蘇轍',
    description: '蘇轍自貶謫歸來後在潁川築齋，名「遺老」，論述知足常樂與修身之道。',
    content: '庚辰之冬，予蒙恩歸自南荒，客於潁川，思歸而不能。諸子憂之曰：「父母老矣，而居室未完，吾儕之責也。」則相與卜築，五年而有成。其南修竹古柏，蕭然如野人之家。乃辟其四楹，加明窗曲檻，為燕居之齋。齋成，求所以名之，予曰：予潁濱遺老也，盍以「遺老」名之？汝曹誌之。汝曹誌之，學道而求寡過，如予今日之處遺老齋可也。',
  },
  {
    id: 'classic-daiyuexuanji',
    category: 'classic',
    dynasty: 'song',
    title: '待月軒記',
    source: '蘇轍',
    description: '蘇轍借月夜待月，探討隱者所言性命之理與人生境界的相合。',
    content: '昔予遊廬山，見隱者焉，為予言性命之理曰：「性猶日也，身猶月也。」人始有性而已，性之所寓為身。天始有日而已，日之所寓為月。日入地中，雖未嘗變，而不為世用，復出於東，然後物無不睹，非命而何？月不自明，由日以為明。築室於斯，辟其東南為小軒。之前廓然無障，幾與天際。每月之望，開戶以須月之至。',
  },
  {
    id: 'classic-shangzhongyong',
    category: 'classic',
    dynasty: 'song',
    title: '傷仲永',
    source: '王安石',
    description: '王安石述神童方仲永因父親利欲薰心不使其學，最終泯然眾人的悲劇。',
    content: '金溪民方仲永，世隸耕。仲永生五年，未嘗識書具，忽啼求之。父異焉，借旁近與之，即書詩四句，並自為其名。其詩以養父母、收族為意，傳一鄉秀才觀之。自是指物作詩立就，其文理皆有可觀者。邑人奇之，稍稍賓客其父，或以錢幣乞之。父利其然也，日扳仲永環謁於邑人，不使學。予聞之也久。明道中，從先人還家，於舅家見之，十二三矣。令作詩，不能稱前時之聞。又七年，還自揚州，復到舅家，問焉。曰：「泯然眾人矣。」',
  },
  {
    id: 'classic-dasimajianyishu',
    category: 'classic',
    dynasty: 'song',
    title: '答司馬諫議書',
    source: '王安石',
    description: '王安石寫給司馬光的回信，堅定闡明變法的原則，表明不恤怨謗、力行新政的決心。',
    content: '某啟：昨日蒙教，竊以為與君實遊處相好之日久，而議事每不合，所操之術多異故也。雖欲強聒，終必不蒙見察，故略上報，不復一一自辨。重念蒙君實視遇厚，於反覆不宜鹵莽，故今具道所以，冀君實或見恕也。蓋儒者所爭，尤在於名實，名實已明，而天下之理得矣。今君實所以見教者，以為侵官、生事、徵利、拒諫，以致天下怨謗也。某則以謂：受命於人主，議法度而修之於朝廷，以授之於有司，不為侵官；舉先王之政，以興利除弊，不為生事；為天下理財，不為徵利；辟邪說，難壬人，不為拒諫。',
  },
  {
    id: 'classic-jiouyangwenzhonggongwen',
    category: 'classic',
    dynasty: 'song',
    title: '祭歐陽文忠公文',
    source: '王安石',
    description: '王安石悼念恩師歐陽修的祭文，高度讚揚其道德文章與堅貞節操。',
    content: '夫事有人力之可致，猶不可期，況乎天理之溟漠，又安可得而推！唯公生有聞於當時，死有傳於後世，苟能如此足矣，而亦又何悲！如公器質之深厚，智識之高遠，而輔學術之精微，故充於文章，見於議論，豪健俊偉，怪巧瑰琦。其積於中者，浩如江河之停蓄；其發於外者，爛如日星之光輝。其清音幽韻，淒如飄風急雨之驟至；其雄辭閎辯，快如輕車駿馬之奔馳。世之學者，無問乎識與不識，而讀其文，則其人可知。',
  },
  {
    id: 'poem-bochuanguazhou',
    category: 'poem',
    dynasty: 'song',
    title: '泊船瓜洲',
    source: '王安石',
    description: '王安石經典抒情絕句，藉春風江南，表達重返朝廷時的思鄉心境。',
    content: '京口瓜洲一水間，鐘山只隔數重山。春風又綠江南岸，明月何時照我還？',
  },
  {
    id: 'poem-dengfeilaifeng',
    category: 'poem',
    dynasty: 'song',
    title: '登飛來峰',
    source: '王安石',
    description: '王安石變法初期的抱負詩，表達高瞻遠矚、不怕困難的政治勇氣與決心。',
    content: '飛來山上千尋塔，聞說雞鳴見日升。不畏浮雲遮望眼，自緣身在最高層。',
  },
  {
    id: 'poem-yuanri',
    category: 'poem',
    dynasty: 'song',
    title: '元日',
    source: '王安石',
    description: '王安石新年氣象詩，以除舊迎新象徵變法革新的萬象更新。',
    content: '爆竹聲中一歲除，春風送暖入屠蘇。千門萬戶曈曈日，總把新桃換舊符。',
  },
  {
    id: 'poem-shuhuyinxianshengbi',
    category: 'poem',
    dynasty: 'song',
    title: '書湖陰先生壁',
    source: '王安石',
    description: '王安石題寫在友人牆壁上的詩，描繪庭院的潔淨與山水景色的生機。',
    content: '茅檐長掃淨無苔，花木成畦手自栽。一水護田將綠繞，兩山排闥送青來。',
  },
  {
    id: 'poem-guizhixiangjinling',
    category: 'poem',
    dynasty: 'song',
    title: '桂枝香·金陵懷古',
    source: '王安石',
    description: '王安石經典金陵懷古詞，以開闊秋景寄託興亡之慨，開豪放詞之先河。',
    content: '登臨送目，正故國晚秋，天氣初肅。千里澄江似練，翠峰如簇。歸帆去棹殘陽裏，背西風、酒旗斜矗。彩舟雲淡，星河鷺起，畫圖難足。念往昔、繁華競逐，嘆門外樓頭，悲恨相續。千古憑高對此，謾嗟榮辱。六朝舊事隨流水，但寒煙、衰草凝綠。至今商女，時時猶唱，後庭遺曲。',
  },
  {
    id: 'poem-gutong',
    category: 'poem',
    dynasty: 'song',
    title: '孤桐',
    source: '王安石',
    description: '王安石以孤桐自況之詩，表達正直不屈、願為世人解憂的崇高懷抱。',
    content: '天質自森森，孤高幾百尋。凌霄不屈己，得地本虛心。歲老根彌壯，陽驕葉更陰。明時思解愠，願斫五弦琴。',
  },
  {
    id: 'classic-xingxian',
    category: 'classic',
    dynasty: 'song',
    title: '興賢',
    source: '王安石',
    description: '王安石政論文章，探討任用賢能對國家興衰的決定性作用。',
    content: '國以任賢使能而興，棄賢專己而衰。此二者必然之勢，古今之通義，流俗所共知耳。何治安之世有之而能興，昏亂之世雖有之亦不興，蓋用之與不用之謂矣。有賢而用，國之福也，有之而不用，猶無有也。商之興也有仲虺、伊尹、其衰也亦有三仁。周之興也同心者十人，其衰也亦有祭公謀父、內史過。兩漢之興也有蕭、曹、寇、鄧之徒，其衰也亦有王嘉、傅喜、陳蕃、李固之眾。由此觀之，有賢而用之者，國之福也，有之而不用，猶無有也。',
  },
  {
    id: 'classic-mochiji',
    category: 'classic',
    dynasty: 'song',
    title: '墨池記',
    source: '曾鞏',
    description: '曾鞏以王羲之墨池為題，論述王羲之書法非天成、而是精力自致的勤學道理。',
    content: '臨川之城東，有地隱然而高，以臨於溪，曰新城。新城之上，有池窪然而方以長，曰王羲之之墨池者，荀伯子《臨川記》雲也。羲之嘗慕張芝，臨池學書，池水盡黑，此為其故跡，豈信然邪？方羲之之不可強以仕，而嘗極東方，出滄海，以娛其意於山水之間，豈其徜徉肆恣，而又嘗自休於此邪？羲之之書晚乃善，則其所能，蓋亦以精力自致者，非天成也。然後世未有能及者，豈其學不如彼邪？則學固豈可以少哉！況欲深造道德者邪！',
  },
  {
    id: 'classic-xingxintingji',
    category: 'classic',
    dynasty: 'song',
    title: '醒心亭記',
    source: '曾鞏',
    description: '曾鞏應歐陽修之請所撰亭記，闡述「與民共樂」的為政理想。',
    content: '滁州之西南，泉水之涯，歐陽公作州之二年，構亭曰「豐樂」，自為記以見其名之意。既又直豐樂之東幾百步，得山之高，構亭曰「醒心」，使鞏記之。凡公與州之賓客者遊焉，則必即豐樂以飲。或醉且勞矣，則必即醒心而望。以見夫群山之相環，雲煙之相滋，曠野之無窮，草樹眾而泉石嘉，使目新乎其所睹，耳新乎其所聞，則其心灑然而醒，更欲久而忘歸也。雖然，公之樂，吾能言之。吾君優遊而無為於上，吾民給足而無憾於下，天下學者皆為材且良，夷狄鳥獸草木之生者皆得其宜，公樂也。',
  },
  {
    id: 'classic-jiouyangsherenshu',
    category: 'classic',
    dynasty: 'song',
    title: '寄歐陽舍人書',
    source: '曾鞏',
    description: '曾鞏寫給歐陽修的書信，論述墓誌銘「史德與史才」的寫作標準。',
    content: '鞏頓首再拜，舍人先生：去秋人還，蒙賜書及所撰先大父墓碑銘，反覆觀誦，感與慚並。夫銘誌之著於世，義近於史，而亦有與史異者。蓋史之於善惡，無所不書；而銘者，蓋古之人有功德、材行、志義之美者，懼後世之不知，則必銘而見之；或納於廟，或存於墓，一也。茍其人之惡，則於銘乎何有？此其所以與史異也。其辭之作，所以使死者無有所憾，生者得致其嚴。而善人喜於見傳，則勇於自立；惡人無有所紀，則以愧而懼。',
  },
  {
    id: 'classic-shuweizhenggongchuanhou',
    category: 'classic',
    dynasty: 'song',
    title: '書魏鄭公傳後',
    source: '曾鞏',
    description: '曾鞏讀魏徵傳記後的隨筆，論述進諫直言應昭示萬世，而非焚稿掩君過。',
    content: '予觀太宗常屈己以從群臣之議，而魏鄭公之徒，喜遭其時，感知己之遇，事之大小，無不諫諍，雖其忠誠自至，亦得君而然也。則思唐之所以治，太宗之所以稱賢主，而前世之君不及者，其淵源皆出於此也。及觀鄭公以諫諍事付史官，而太宗怒之，薄其恩禮，失終始之義，則未嘗不反覆嗟惜，恨其不思，而益知鄭公之賢焉。夫以焚其稿為掩君之過，而使後世傳之，則是使後世不見稿之是非，而必其過常在於君，美常在於己也，豈愛其君之謂歟？',
  },
  {
    id: 'classic-zhanguocemuluxu',
    category: 'classic',
    dynasty: 'song',
    title: '戰國策目錄序',
    source: '曾鞏',
    description: '曾鞏為《戰國策》校勘整理所作之序，批判遊士縱橫權謀、偷為一切之大禍。',
    content: '劉向所定戰國策三十三篇，臣訪之士大夫家，始盡得其書，正其誤謬。向敘此書，言周之先，明教化，修法度，所以大治；及其後，謀詐用，而仁義之路塞，所以大亂。戰國之遊士則不然。不知道之可信，而樂於說之易合。其設心注意，偷為一切之計而已。故論詐之便而諱其敗，言戰之善而蔽其患。卒至蘇秦、商鞅、孫臏、吳起、李斯之徒，以亡其身；而諸侯及秦用之者，亦滅其國。其為世之大禍明矣，而俗猶莫之寤也。',
  },
  {
    id: 'classic-nanqishumuluxu',
    category: 'classic',
    dynasty: 'song',
    title: '南齊書目錄序',
    source: '曾鞏',
    description: '曾鞏校訂《南齊書》後作之序，探討史書是非得失的法戒功能及良史條件。',
    content: '《南齊書》，八紀，十一志，四十列傳，合五十九篇，梁蕭子顯撰。臣等因校正其訛謬，而敘其篇目。古之所謂良史者，其明必足以周萬事之理，其道必足以適天下之用，其智必足以通難知之意，其文必足以發難顯之情，然後其任可得而稱也。兩漢以來為史者，去之遠矣。司馬遷自五帝三王既歿數千載之後，區區掇拾，以集著其善惡之跡，興廢之端，斯亦可謂奇矣。然而是非顛倒而採摭謬亂者，亦豈少哉！子顯之於斯文，喜自馳騁，其更改破析刻彫藻繢之變尤多，而其文益下。',
  },
  {
    id: 'classic-zenggong-zenglianershengxu',
    category: 'classic',
    dynasty: 'song',
    title: '贈黎安二生序',
    source: '曾鞏',
    description: '曾鞏送別蜀地學者黎生、安生時所撰，勉勵讀書人守道信古、不急於迎合世俗。',
    content: '趙郡蘇軾，予之同年友也。自蜀以書至京師遺予，稱蜀之士曰：黎生、安生者。既而黎生攜其文數十萬言，安生攜其文亦數千言，辱以顧予。讀其文，誠閎壯雋偉，善反復馳騁，窮盡事理；而其材力之放縱，若不可極者也。頃之，黎生補江陵府司法參軍。將行，請予言以為贈。予曰：予之知生，既得之於心矣，乃將以言相求於外邪？黎生曰：生與安生之學於斯文，里之人皆笑以為迂闊。今求子之言，蓋將解惑於里人。予聞之，自顧而笑。夫世之迂闊，孰有甚於予乎？知信乎古，而不知合乎世；知志乎道，而不知同乎俗。生其無急於解里人之惑，則於是焉，必能擇而取之。',
  },
  {
    id: 'poem-yumeirencao',
    category: 'poem',
    dynasty: 'song',
    title: '虞美人草',
    source: '曾鞏',
    description: '曾鞏七言古詩，藉虞美人草詠嘆楚漢興亡，表達剛強必死而仁義長存的哲理。',
    content: '鴻門玉斗紛如雪，十萬降兵夜流血。咸陽宮殿三月紅，霸業已隨煙燼滅。剛強必死仁義王，陰陵失道非天亡。英雄本學萬人敵，何用屑屑悲紅粧。三軍散盡旌旗倒，玉帳佳人坐中老。香魂夜逐劍光飛，青血化為原上草。芳心寂莫寄寒枝，舊曲聞來似斂眉。哀怨徘徊愁不語，恰如初聽楚歌時。滔滔逝水流今古，漢楚興亡兩丘土。當年遺事久成空，慷慨樽前為誰舞。',
  },
  {
    id: 'poem-chengnan',
    category: 'poem',
    dynasty: 'song',
    title: '城南',
    source: '曾鞏',
    description: '曾鞏寫景哲理詩，藉暮春草木常綠，寓意為人為學應深厚持久。',
    content: '雨過橫塘水滿堤，亂山高下路東西。一番桃李花開盡，惟有青青草色齊。',
  },
  {
    id: 'poem-yongliu',
    category: 'poem',
    dynasty: 'song',
    title: '詠柳',
    source: '曾鞏',
    description: '曾鞏詠物諷喻詩，以柳條倚東風而狂，諷刺得志便猖狂的勢利小人。',
    content: '亂條猶未變初黃，倚得東風勢便狂。解把飛花蒙日月，不知天地有清霜。',
  },

  {
    id: 'poem-song-xiaochi',
    category: 'poem',
    dynasty: 'song',
    title: '小池',
    source: '楊萬里',
    description: '「台灣國小」學段經典選文，楊萬里描寫初夏池塘自然生機的清新之作。',
    content: '泉眼無聲惜細流，樹陰照水愛晴柔。小荷才露尖尖角，早有蜻蜓立上頭。',
  },
  {
    id: 'poem-song-zengliujingwen',
    category: 'poem',
    dynasty: 'song',
    title: '贈劉景文',
    source: '蘇軾',
    description: '「台灣國小」學段常見詩選，蘇軾勉勵好友珍惜晚景與勉勵心志之作。',
    content: '荷盡已無擎雨蓋，菊殘猶有傲霜枝。一年好景君須記，最是橙黃橘綠時。',
  },
  {
    id: 'poem-song-meihua',
    category: 'poem',
    dynasty: 'song',
    title: '梅花',
    source: '王安石',
    description: '「台灣國小」學段經典，王安石以梅花凌寒獨開喻高潔品格的名篇。',
    content: '牆角數枝梅，凌寒獨自開。遙知不是雪，為有暗香來。',
  },
  {
    id: 'poem-song-guolingdingyang',
    category: 'poem',
    dynasty: 'song',
    title: '過零丁洋',
    source: '文天祥',
    description: '「台灣國中」學段經典，文天祥展現忠貞不屈、視死如歸的愛國名著。',
    content: '辛苦遭逢起一經，干戈寥落四周星。山河破碎風飄絮，身世浮沉雨打萍。惶恐灘頭說惶恐，零丁洋裡嘆零丁。人生自古誰無死？留取丹心照汗青。',
  },
  {
    id: 'poem-song-guanshuyougan',
    category: 'poem',
    dynasty: 'song',
    title: '觀書有感',
    source: '朱熹',
    description: '「台灣國中」學段必讀，朱熹藉方塘池水比喻求知需不斷吸收新知之哲理詩。',
    content: '半畝方塘一鑑開，天光雲影共徘徊。問渠那得清如許？為有源頭活水來。',
  },
  {
    id: 'poem-song-wanghaichao',
    category: 'poem',
    dynasty: 'song',
    title: '望海潮·東南形勝',
    source: '柳永',
    description: '「台灣高中」學段經典詞牌名篇，柳永以開闊筆調描繪杭州湖山之美與都市繁華。',
    content: '東南形勝，三吳都會，錢塘自古繁華。煙柳畫橋，風簾翠幕，參差十萬人家。雲樹繞堤沙，怒濤卷霜雪，天塹無涯。市列珠璣，戶盈羅綺，競豪奢。重湖疊巘清嘉。有三秋桂子，十里荷花。羌管弄晴，菱歌泛夜，嬉嬉釣叟蓮娃。千騎擁高牙。乘醉聽簫鼓，吟賞煙霞。異日圖將好景，歸去鳳池誇。',
  },
  {
    id: 'poem-song-yulinling',
    category: 'poem',
    dynasty: 'song',
    title: '雨霖鈴·寒蟬淒切',
    source: '柳永',
    description: '「台灣高中」學段必備宋詞，柳永委婉抒寫別離之苦，為婉約詞派代表作。',
    content: '寒蟬淒切，對長亭晚，驟雨初歇。都門帳飲無緒，留戀處、蘭舟催發。執手相看淚眼，竟無語凝噎。念去去、千里煙波，暮靄沉沉楚天闊。多情自古傷離別，更那堪、冷落清秋節！今宵酒醒何處？楊柳岸、曉風殘月。此去經年，應是良辰好景虛設。便縱有、千種風情，更與何人說？',
  },
  {
    id: 'poem-song-bashengganzhou',
    category: 'poem',
    dynasty: 'song',
    title: '八聲甘州·對瀟瀟暮雨灑江天',
    source: '柳永',
    description: '「台灣高中」學段常見宋詞，柳永借登高所見秋景，流露強烈的羈旅鄉愁。',
    content: '對瀟瀟暮雨灑江天，一番洗清秋。漸霜風淒緊，關河冷落，殘照當樓。是處紅衰翠減，苒苒物華休。唯有長江水，無語東流。不忍登高臨遠，望故鄉渺邈，歸思難收。嘆年來蹤跡，何事苦淹留？想佳人、妝樓顒望，誤幾回、天際識歸舟。爭知我、倚欄杆處，正恁凝愁！',
  },

  /* 李清照經典詩詞與文章集 */
  {
    id: 'poem-lixiang-yujiaao-tiangao',
    category: 'poem',
    dynasty: 'song',
    title: '漁家傲·天接雲濤連曉霧',
    source: '李清照',
    description: '李清照豪放代表作，展現九萬里風鵬正舉的宏大境界與浪漫情懷。',
    content: '天接雲濤連曉霧，星河欲轉千帆舞。彷彿夢魂歸帝所，聞天語，殷勤問我歸何處。我報路長嗟日暮，學詩謾有驚人句。九萬里風鵬正舉。風休住，蓬舟吹取三山去！',
  },
  {
    id: 'poem-lixiang-rumengling-zhaofeng',
    category: 'poem',
    dynasty: 'song',
    title: '如夢令·昨夜雨疏風驟',
    source: '李清照',
    description: '李清照惜春名篇，「應是綠肥紅瘦」膾炙人口。',
    content: '昨夜雨疏風驟，濃睡不消殘酒。試問卷簾人，卻道海棠依舊。知否，知否？應是綠肥紅瘦。',
  },
  {
    id: 'poem-lixiang-yongyuele',
    category: 'poem',
    dynasty: 'song',
    title: '永遇樂·落日鎔金',
    source: '李清照',
    description: '李清照晚年元宵懷舊名篇，抒發今昔巨變與故國之思。',
    content: '落日鎔金，暮雲合璧，人在何處。染柳煙濃，吹梅笛怨，春意知幾許。元宵佳節，融和天氣，次第豈無風雨。來相召、香車寶馬，謝他酒朋詩侶。中州盛日，閨門多暇，記得偏重三五。鋪翠冠兒，撚金雪柳，簇帶爭濟楚。如今憔悴，風鬟霜鬢，怕見夜間出去。不如向、簾兒底下，聽人笑語。',
  },
  {
    id: 'poem-lixiang-fenghuang',
    category: 'poem',
    dynasty: 'song',
    title: '鳳凰臺上憶吹簫·香冷金猊',
    source: '李清照',
    description: '李清照傷別名作，「新來瘦，非干病酒，不是悲秋」情深意切。',
    content: '香冷金猊，被翻紅浪，起來慵自梳頭。任寶奩塵滿，日上簾鉤。生怕離懷別苦，多少事、欲說還休。新來瘦，非干病酒，不是悲秋。休休，這回去也，千萬遍《陽關》，也則難留。念武陵人遠，煙鎖秦樓。惟有樓前流水，應念我、終日凝眸。凝眸處，從今又添，一段新愁。',
  },
  {
    id: 'poem-lixiang-huanxisha-xiutaji',
    category: 'poem',
    dynasty: 'song',
    title: '浣溪沙·繡面芙蓉一笑開',
    source: '李清照',
    description: '描繪女子嬌羞美麗與相思之意，筆觸生動。',
    content: '繡面芙蓉一笑開，斜飛寶鴨襯香腮。眼波才動被人猜。一面風情深有韻，半箋嬌恨寄幽懷。月移花影約重來。',
  },
  {
    id: 'poem-lixiang-huanxisha-shangji',
    category: 'poem',
    dynasty: 'song',
    title: '浣溪沙·髻子傷春慵更梳',
    source: '李清照',
    description: '抒寫女子傷春慵懶與深閨幽思。',
    content: '髻子傷春慵更梳。晚風庭院落梅初。淡雲來往月疏疏。玉鴨熏爐閒瑞腦，朱櫻斗帳掩流蘇。通犀還解辟寒無。',
  },
  {
    id: 'poem-lixiang-huanxisha-moshang',
    category: 'poem',
    dynasty: 'song',
    title: '浣溪沙·莫許杯深琥珀濃',
    source: '李清照',
    description: '寫沉醉幽思與微醺情態。',
    content: '莫許杯深琥珀濃，未成沈醉意先融。疏鐘已應晚來風。瑞腦香消魂夢斷，辟寒金小髻鬟鬆。醒時空對燭花紅。',
  },
  {
    id: 'poem-lixiang-huanxisha-xiaoyuan',
    category: 'poem',
    dynasty: 'song',
    title: '浣溪沙·小院閒窗春色深',
    source: '李清照',
    description: '描繪深院春深、細雨梨花的幽寂之美。',
    content: '小院閒窗春色深，重簾未捲影沈沈。倚樓無語理瑤琴。遠岫出雲催薄暮，細風吹雨弄輕陰。梨花欲謝恐難禁。',
  },
  {
    id: 'poem-lixiang-linjiangxian-tingyuan',
    category: 'poem',
    dynasty: 'song',
    title: '臨江仙·庭院深深深幾許',
    source: '李清照',
    description: '李清照擬歐陽修詞，寫極致的幽寂閨愁。',
    content: '庭院深深深幾許，雲窗霧閣春遲。為誰憔悴損芳姿。夜來清夢好，應是發南枝。玉瘦香濃情共遠，遊蜂掠盡粉絲。如今風雨滿西樓。多情移徙處，何用化浮漚。',
  },
  {
    id: 'poem-lixiang-linjiangxian-meihua',
    category: 'poem',
    dynasty: 'song',
    title: '臨江仙·梅',
    source: '李清照',
    description: '李清照詠梅名作，以梅花自喻飄零幽獨。',
    content: '庭院深深深幾許，雲窗霧閣常扃。柳梢梅萼漸分明。春歸秣陵樹，人老建康城。感月吟風多少事，如今老去無成。誰憐憔悴更凋零。試燈無意思，踏雪沒心情。',
  },
  {
    id: 'poem-lixiang-dielianhua-huanji',
    category: 'poem',
    dynasty: 'song',
    title: '蝶戀花·暖日晴風初破凍',
    source: '李清照',
    description: '寫早春景色與閨中懷人之情。',
    content: '暖日晴風初破凍，柳眼梅腮，已覺春心動。酒意詩情誰與共？淚融殘粉花鈿重。乍試夾衫金縷縫，山枕斜欹，枕損釵頭鳳。獨抱濃愁無好夢，夜闌猶剪燈花弄。',
  },
  {
    id: 'poem-lixiang-nianyunu-xiaoqiao',
    category: 'poem',
    dynasty: 'song',
    title: '念奴嬌·蕭條庭院',
    source: '李清照',
    description: '寫春寒料峭中的幽獨與相思。',
    content: '蕭條庭院，又急風細雨，重門須閉。寵柳嬌花寒食近，種種惱人天氣。險韻詩成，扶頭酒醒，別是閒滋味。征鴻過盡，萬千心事難寄。樓上幾日春寒，簾垂四面，玉闌干慵倚。被冷香消新夢覺，不許愁人不起。清露晨流，新桐初引，多少游春意。日高煙斂，更看今日晴未。',
  },
  {
    id: 'poem-lixiang-yousuosi',
    category: 'poem',
    dynasty: 'song',
    title: '怨王孫·湖上風來波浩渺',
    source: '李清照',
    description: '寫湖景浩渺與晚秋暮色之美。',
    content: '湖上風來波浩渺，秋已暮、紅稀香少。水光山色與人親，說不盡、無窮好。蓮子已成菊未老，青露洗、蘋花汀草。眠沙鷗鷺不回頭，似也恨、人歸早。',
  },
  {
    id: 'poem-lixiang-pusa-fengting',
    category: 'poem',
    dynasty: 'song',
    title: '菩薩蠻·風柔日薄春猶早',
    source: '李清照',
    description: '早春感受寒意與懷人之作。',
    content: '風柔日薄春猶早，夾衫乍試心情好。睡起髻鬟呆，不知勻面來。惜花春起早，愛月夜眠遲。莫使燭花殘，相思何處干。',
  },
  {
    id: 'poem-lixiang-shuangtianling-xueren',
    category: 'poem',
    dynasty: 'song',
    title: '霜天曉角·雪裡已知春信至',
    source: '李清照',
    description: '寫雪中尋梅與春信早至。',
    content: '雪裡已知春信至，寒梅點綴瓊枝膩。香臉半開嬌旖旎，當庭際，玉人浴出新妝洗。造化可能偏有意，故教明月玲瓏地。共賞金尊沈綠蟻，莫辭醉，此花不與群花比。',
  },
  {
    id: 'poem-lixiang-zhegutian-anxiang',
    category: 'poem',
    dynasty: 'song',
    title: '鷓鴣天·暗淡輕黃體性柔',
    source: '李清照',
    description: '專詠桂花，尊桂花為花中第一流。',
    content: '暗淡輕黃體性柔，情疏跡遠只香留。何須淺碧深紅色，自是花中第一流。梅定妒，菊應羞，畫闌開處冠中秋。騷人可煞無情思，何事當年不見收。',
  },
  {
    id: 'poem-lixiang-zhegutian-hanshuang',
    category: 'poem',
    dynasty: 'song',
    title: '鷓鴣天·寒日蕭蕭上瑣窗',
    source: '李清照',
    description: '寫秋日幽冷與思念舊人。',
    content: '寒日蕭蕭上瑣窗，梧桐應恨夜來霜。酒闌更喜團茶苦，夢斷偏宜瑞腦香。秋已盡，日猶長，仲宣懷遠更淒涼。不如隨分尊前醉，莫負東籬菊自黃。',
  },
  {
    id: 'poem-lixiang-nanhehua',
    category: 'poem',
    dynasty: 'song',
    title: '南歌子·天上星河轉',
    source: '李清照',
    description: '深夜感懷星月流轉與長夜難眠。',
    content: '天上星河轉，人間簾幕垂。涼生枕簟淚痕滋。起解羅衣聊自就，小池塘。風細落花深，簾外殘香在。此時此夜難為情，獨宿孤眠怎奈向。',
  },
  {
    id: 'poem-lixiang-gujiuhuan',
    category: 'poem',
    dynasty: 'song',
    title: '憶秦娥·臨高閣',
    source: '李清照',
    description: '借梧桐秋雨抒寫心中的淒清孤寂。',
    content: '臨高閣，亂山平野煙光薄。煙光薄，棲鴉歸後，暮天聞角。斷香殘酒情懷惡，西風催襯梧桐落。梧桐落，又還秋色，又還寂寞。',
  },
  {
    id: 'poem-lixiang-tibayonglou',
    category: 'poem',
    dynasty: 'song',
    title: '題八詠樓',
    source: '李清照',
    description: '李清照避難金華登八詠樓所作，氣勢磅礴，感慨深沉。',
    content: '千古風流八詠樓，江山留與後人愁。水通南國三千里，氣壓江城十四州。',
  },
  {
    id: 'poem-lixiang-xiaomeng',
    category: 'poem',
    dynasty: 'song',
    title: '曉夢',
    source: '李清照',
    description: '描繪清晨夢醒、意境超凡之詩作。',
    content: '曉夢隨疏鐘，飄然躡雲霞。因過西天竺，偶到梵王家。蓮華大如蓋，馥馥清芬發。臨引生妙法，談笑忘朝夕。',
  },
  {
    id: 'poem-lixiang-oucheng',
    category: 'poem',
    dynasty: 'song',
    title: '偶成',
    source: '李清照',
    description: '李清照感懷歲月流逝與青春不再之名詩。',
    content: '十五年前花底下，點檢芳名撫妾身。如今老去無心緒，點檢芳名撫自身。',
  },
  {
    id: 'poem-lixiang-ganhuai',
    category: 'poem',
    dynasty: 'song',
    title: '感懷',
    source: '李清照',
    description: '感懷戰亂離散與江南春晚。',
    content: '宣和廿載舊承平，花底鶯啼白髮生。今日江南春色老，不堪重聽子規聲。',
  },
  {
    id: 'poem-lixiang-shanghanhu',
    category: 'poem',
    dynasty: 'song',
    title: '上樞密韓公工部尚書胡公',
    source: '李清照',
    description: '李清照贈別使臣赴北方議和之古詩，寄予收復中原之期望。',
    content: '右司公使使，東壁照西清。意氣風雲動，聲名天地行。皇華乘紫騕，白筆染清冰。北闕辭嚴命，南州借寵英。中原父老淚，幾歲望昇平。回首江山在，何時復故京。',
  },
  {
    id: 'classic-lixiang-cizun',
    category: 'classic',
    dynasty: 'song',
    title: '詞論',
    source: '李清照',
    description: '李清照著名文藝理論散文，提出「詞別是一家」之著名論點，系統論述詞派審美。',
    content: '樂府聲詩並著，最盛於唐。開元天寶間，有李白、杜甫、高適、岑參，其詩曲盡人情，字字珠璣。李白作《菩薩蠻》、《憶秦娥》，開後代詞家之門。至唐季及五代，溫庭筠、韋莊、馮延巳、李璟、李煜諸人，各展才情，詞體大備。入宋，晏元獻、歐陽文忠、蘇子容，文章冠絕一代，然於詞則未盡善也。至柳耆卿，始變舊聲為慢詞，穴調裁度，鋪敘展衍，然詞格卑下。張子野、宋子京兄弟，雖有佳作，然破碎未成一家。至晏叔原、賀方回、秦少游、黃魯直，始能自立門戶。晏苦無鋪敘，賀少典重，秦則專主情致而少筋骨，黃則尚理趣而多流於硬澀。蘇子瞻長於文章，以詩入詞，往往不協音律，句讀不葺。蓋詞別是一家，須辨音律，分五音六律、清濁高下，不可等閒視之。',
  },
  {
    id: 'classic-lixiang-shangqichong',
    category: 'classic',
    dynasty: 'song',
    title: '打馬圖序',
    source: '李清照',
    description: '李清照為博弈遊戲《打馬圖經》所撰序言，論述博弈心法與南渡身世之感懷。',
    content: '慧即通，通即無所不達；專即精，精即無所不妙。故庖丁之解牛，郢人之運斤，師曠之聽，離婁之視，大至於堯、舜之仁，桀、紂之惡，小至於擲豆起蠅、巾角拂棋，皆臻至理者何？妙而已。後世之人，不惟學聖人之道，不至聖處。雖嬉戲之事，亦得其依稀彷彿而遂止者多矣。夫博者無他，爭先術耳，故專者能之。予性喜博，凡所謂博者皆耽之，晝夜每忘寢食，但平生隨多寡未嘗不進者何？精而已。自南渡來，流離遷徙，盡散博具，故罕為之，然實未嘗忘於胸中也。今年冬十月朔，聞淮上警報，江浙之人，自東走西，自南走北；居山林者謀入城市，居城市者謀入山林，旁午絡繹，莫卜所之。易安居士亦自臨安泝流，涉嚴灘之險，抵金華，卜居陳氏第。乍釋舟楫而見軒窗，意頗釋然。更長燭明，奈此良夜何？於是乎博弈之事講矣。且長行、葉子、博塞、彈棋，近世無傳者。打揭、大小、豬窩、挨鬼、胡畫、數倉、賭快之類，皆鄙俚，不經見。藏鬮、樗蒲、雙蹙融，近漸廢絕。選仙、加減、插關太，質魯任命，無所施人智巧。大小象戲、奕棋，又惟可容二人。獨采選、打馬，特為閨房雅戲。嘗恨采選叢繁，勞於檢閱，故能通者少，難遇勍敵。打馬簡要，而苦無文采。按打馬世有兩種：一種一將十馬者，謂之關西馬；一種無將二十馬者，謂之依經馬。流行既久，各有圖經凡例可考，行移賞罰，互有同異。又宣和間，人取兩種馬，參雜加減，大約交加僥倖，古意盡矣，所謂宣和馬者是也。予獨愛依經馬，因取其賞罰互度，每事作數語，隨事附見，使兒輩圖之。不獨施之博徒，實足貽諸好事，使千萬世後，知命辭打馬，始自易安居士也。紹興四年十一月二十四日，易安室序。',
  },
  {
    id: 'classic-lixiang-damatuxi',
    category: 'classic',
    dynasty: 'song',
    title: '打馬賦',
    source: '李清照',
    description: '借打馬棋戲抒發兵法謀略與「但願相將過淮水」收復中原志向的名篇賦作。',
    content: '歲令雲徂，盧或可呼，千金一擲，百萬十都。尊俎具陳，已行揖讓之禮；主賓既醉，不有博弈者乎？打馬爰興，摴蒱遂廢，實博弈之上流，乃閨房之雅戲。齊驅驥騄，疑穆王萬里之行；間列玄黃，類楊氏五家之隊。珊珊佩響，方驚玉蹬之敲；落落星羅，忽見連錢之碎。若乃吳江楓冷，胡山葉飛；玉門關閉，沙苑草肥；臨波不渡，似惜障泥。或出入用奇，有類昆陽之戰；或優游仗義，正如涿鹿之師；或聞望久高，脫復庾郎之失；或聲名素昧，便同癡叔之奇。亦有緩緩而歸，昂昂而出，鳥道驚馳，蟻封安步。崎嶇峻坂，未遇王良；跼促鹽車，難逢造父。且夫丘陵雲遠，白雲在天，心存戀豆，志在著鞭。止蹄黃葉，何異金錢？用五十六采之間，行九十一路之內。明以賞罰，覈以殿最。運指麾於方寸之中，決勝負於幾微之外。且好勝者人之常情，小藝者士之末技。說梅止渴，稍蘇奔競之心；畫餅充飢，少謝騰驤之志。將圖實效，故臨難而不回；欲報厚恩，故知機而先退。或銜枚緩進，已踰關塞之艱；或賈勇爭先，莫悟穽塹之墜。皆由不知止足，自貽尤悔。況為之不已，事實見於正經；用之以誠，義必合於天德。故繞床大叫，五木皆盧；瀝酒一呼，六子盡赤。平生不負，遂成劍閣之師；別墅未逾，已破淮淝之賊。今日豈無元子，明時不乏安石，又何必陶長沙博局之投，正當師袁彥道之擲也。辭曰：佛狸定見卯年死，貴賤紛紛尚流徙。滿眼驊騮雜騄駬，時危安得真致此？木蘭橫戈好女子，老矣誰能志千里？但願相將過淮水。',
  },
  {
    id: 'classic-lixiang-shanghubuji',
    category: 'classic',
    dynasty: 'song',
    title: '投翰林學士綦崇禮啟',
    source: '李清照',
    description: '李清照晚年自敘生平駢體名篇，敘述身世罹難與蒙恩得救之肺腑之言。',
    content: '妾身遭世變，漂泊江南。不幸夫死家破，金石散失。後遭欺紿，誤入繼室，遽被摧辱。身陷囹圄，幾不自保。伏惟內翰學士閣下，德冠朝端，仁同海嶽。秉正持重，力賜周旋，使得脫離虎口，洗雪幽冤。重見天日，再生之恩，銘心鏤骨。特具短啟，叩謝德庇。感佩之至，俯首拜陳。',
  },
  {
    id: 'classic-jinshiluhouxu',
    category: 'classic',
    dynasty: 'song',
    title: '金石錄後序',
    source: '李清照',
    description: '李清照著名的散文長篇巨作，記述與趙明誠收藏金石文物及經歷兵亂之悲歡離合。',
    content: '右《金石錄》三十卷者何？趙侯德父所輯也。取上自三代，下訖九代，凡見於金石刻者二千卷，皆抄錄妄謬，辨別疑似，為三十卷。德父始為太學生，每朔望出，質衣得錢五百，入相國寺，估尋碑刻。歸則相對展玩，自謂貧士樂在聲色犬馬之上。後二十年，官至守郡，食肉衣絲，無復昔日之樂。然趙、李兩姓，世皆儒素，至德父乃酷嗜金石。後逢靖康之難，避亂南方，書籍金石盡散失於兵火。今余年老孤獨，追思昔日夫妻共賞金石之樂，如在夢寐。故作此序，述其始末云爾。',
  },
]
